import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Upload: any;
};

export type BenefitsElementItemType = {
  readonly __typename?: 'BenefitsElementItemType';
  readonly benefitsElement: BenefitsElementType;
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type BenefitsElementType = {
  readonly __typename?: 'BenefitsElementType';
  readonly benefitselementitemSet: ReadonlyArray<BenefitsElementItemType>;
  readonly buttonLink?: Maybe<Scalars['String']>;
  readonly buttonText?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly title: Scalars['String'];
};

export type BranchType = {
  readonly __typename?: 'BranchType';
  readonly gebiet?: Maybe<Scalars['String']>;
  readonly ort?: Maybe<Scalars['String']>;
  readonly plz?: Maybe<Scalars['String']>;
  readonly sid: Scalars['String'];
  readonly standort?: Maybe<Scalars['String']>;
  readonly standortExtern?: Maybe<Scalars['String']>;
  readonly strasse?: Maybe<Scalars['String']>;
};

export type BrandedLandingpageLocationsApplicationType = {
  readonly __typename?: 'BrandedLandingpageLocationsApplicationType';
  readonly brandedLandingpage: LandingpageBrandedType;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly sid?: Maybe<Scalars['String']>;
};

export type BrandedLocationElementType = {
  readonly __typename?: 'BrandedLocationElementType';
  readonly brandedLandingpage: LandingpageBrandedType;
  readonly id: Scalars['ID'];
  readonly slug: Scalars['String'];
  readonly title: Scalars['String'];
};

export type BrandedLogoType = {
  readonly __typename?: 'BrandedLogoType';
  readonly brandedLandingpage: LandingpageBrandedType;
  readonly brandedLogo?: Maybe<Scalars['String']>;
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly id: Scalars['ID'];
};

export type ClientLandingpageLocationsApplicationType = {
  readonly __typename?: 'ClientLandingpageLocationsApplicationType';
  readonly clientLandingpage: LandingpageClientType;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly sid?: Maybe<Scalars['String']>;
};

export type ClientLandingpageLocationsType = {
  readonly __typename?: 'ClientLandingpageLocationsType';
  readonly clientLandingpage: LandingpageClientType;
  readonly id: Scalars['ID'];
  readonly slug: Scalars['String'];
  readonly title: Scalars['String'];
};

export type CloudinaryImageType = {
  readonly __typename?: 'CloudinaryImageType';
  readonly alt?: Maybe<Scalars['String']>;
  readonly image: Scalars['String'];
};

export type ConfigurationType = {
  readonly __typename?: 'ConfigurationType';
  readonly key: Scalars['String'];
  readonly value: Scalars['String'];
};

export type CreateApplicationMutationInput = {
  readonly above18?: InputMaybe<Scalars['Boolean']>;
  readonly academicDegree?: InputMaybe<Scalars['Boolean']>;
  readonly apprenticeship?: InputMaybe<Scalars['Boolean']>;
  readonly availableFrom?: InputMaybe<Scalars['Date']>;
  readonly branchId?: InputMaybe<Scalars['String']>;
  readonly citizenship?: InputMaybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly countryCode: Scalars['String'];
  readonly desiredJobLocation?: InputMaybe<Scalars['String']>;
  readonly desiredPosition?: InputMaybe<Scalars['String']>;
  readonly desiredSalary?: InputMaybe<Scalars['Int']>;
  readonly desiredSalaryCurrency?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly fileCv?: InputMaybe<Scalars['Upload']>;
  readonly fileOthers?: InputMaybe<Scalars['Upload']>;
  readonly firstName: Scalars['String'];
  readonly greeting?: InputMaybe<Scalars['String']>;
  readonly homeOffice?: InputMaybe<Scalars['Boolean']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly isSpontaneous?: InputMaybe<Scalars['Boolean']>;
  readonly jobId?: InputMaybe<Scalars['String']>;
  readonly lastName: Scalars['String'];
  readonly marketingPreferencesStatus?: InputMaybe<Scalars['Boolean']>;
  readonly marketingPreferencesType?: InputMaybe<Scalars['String']>;
  readonly maxCommuteDistanceKm?: InputMaybe<Scalars['Int']>;
  readonly noticePeriod?: InputMaybe<Scalars['String']>;
  readonly number: Scalars['String'];
  readonly numberMonthsUpdateCheck?: InputMaybe<Scalars['Int']>;
  readonly phone: Scalars['String'];
  readonly phoneCountryCode: Scalars['String'];
  readonly privacyConsentStatus?: InputMaybe<Scalars['Boolean']>;
  readonly privacyConsentType?: InputMaybe<Scalars['String']>;
  readonly privacyConsentVersion?: InputMaybe<Scalars['String']>;
  readonly relocationWillingness?: InputMaybe<Scalars['Boolean']>;
  readonly remarks?: InputMaybe<Scalars['String']>;
  readonly schaltungsId?: InputMaybe<Scalars['String']>;
  readonly shiftPreferences?: InputMaybe<Scalars['String']>;
  readonly sid?: InputMaybe<Scalars['String']>;
  readonly street: Scalars['String'];
  readonly termsAndConditionsStatus?: InputMaybe<Scalars['Boolean']>;
  readonly transactionId?: InputMaybe<Scalars['String']>;
  readonly varCampaign?: InputMaybe<Scalars['String']>;
  readonly varContent?: InputMaybe<Scalars['String']>;
  readonly varMedium?: InputMaybe<Scalars['String']>;
  readonly varSource?: InputMaybe<Scalars['String']>;
  readonly varTerm?: InputMaybe<Scalars['String']>;
  readonly varType: Scalars['String'];
  readonly vehicleAvailable?: InputMaybe<Scalars['Boolean']>;
  readonly whatsappAllowedStatus?: InputMaybe<Scalars['Boolean']>;
  readonly workpermit?: InputMaybe<Scalars['Boolean']>;
  readonly zipcode: Scalars['String'];
};

export type CreateApplicationMutationPayload = {
  readonly __typename?: 'CreateApplicationMutationPayload';
  readonly above18?: Maybe<Scalars['Boolean']>;
  readonly academicDegree?: Maybe<Scalars['Boolean']>;
  readonly apprenticeship?: Maybe<Scalars['Boolean']>;
  readonly availableFrom?: Maybe<Scalars['Date']>;
  readonly branchId?: Maybe<Scalars['String']>;
  readonly citizenship?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly clientMutationId?: Maybe<Scalars['String']>;
  readonly countryCode: Scalars['String'];
  readonly desiredJobLocation?: Maybe<Scalars['String']>;
  readonly desiredPosition?: Maybe<Scalars['String']>;
  readonly desiredSalary?: Maybe<Scalars['Int']>;
  readonly desiredSalaryCurrency?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName: Scalars['String'];
  readonly greeting?: Maybe<Scalars['String']>;
  readonly homeOffice?: Maybe<Scalars['Boolean']>;
  readonly isSpontaneous?: Maybe<Scalars['Boolean']>;
  readonly jobId?: Maybe<Scalars['String']>;
  readonly lastName: Scalars['String'];
  readonly marketingPreferencesStatus?: Maybe<Scalars['Boolean']>;
  readonly marketingPreferencesType?: Maybe<Scalars['String']>;
  readonly maxCommuteDistanceKm?: Maybe<Scalars['Int']>;
  readonly noticePeriod?: Maybe<Scalars['String']>;
  readonly number: Scalars['String'];
  readonly numberMonthsUpdateCheck?: Maybe<Scalars['Int']>;
  readonly phone: Scalars['String'];
  readonly phoneCountryCode: Scalars['String'];
  readonly privacyConsentStatus?: Maybe<Scalars['Boolean']>;
  readonly privacyConsentType?: Maybe<Scalars['String']>;
  readonly privacyConsentVersion?: Maybe<Scalars['String']>;
  readonly relocationWillingness?: Maybe<Scalars['Boolean']>;
  readonly remarks?: Maybe<Scalars['String']>;
  readonly schaltungsId?: Maybe<Scalars['String']>;
  readonly shiftPreferences?: Maybe<Scalars['String']>;
  readonly sid?: Maybe<Scalars['String']>;
  readonly street: Scalars['String'];
  readonly success?: Maybe<Scalars['Boolean']>;
  readonly termsAndConditionsStatus?: Maybe<Scalars['Boolean']>;
  readonly transactionId?: Maybe<Scalars['String']>;
  readonly varCampaign?: Maybe<Scalars['String']>;
  readonly varContent?: Maybe<Scalars['String']>;
  readonly varMedium?: Maybe<Scalars['String']>;
  readonly varSource?: Maybe<Scalars['String']>;
  readonly varTerm?: Maybe<Scalars['String']>;
  readonly varType: Scalars['String'];
  readonly vehicleAvailable?: Maybe<Scalars['Boolean']>;
  readonly whatsappAllowedStatus?: Maybe<Scalars['Boolean']>;
  readonly workpermit?: Maybe<Scalars['Boolean']>;
  readonly zipcode: Scalars['String'];
};

export type CtaElementType = {
  readonly __typename?: 'CtaElementType';
  readonly buttonText?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly linkUrl?: Maybe<Scalars['String']>;
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly subline?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type DynamicLandingpageElementsConnection = {
  readonly __typename?: 'DynamicLandingpageElementsConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<DynamicLandingpageElementsEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `DynamicLandingpageElements` and its cursor. */
export type DynamicLandingpageElementsEdge = {
  readonly __typename?: 'DynamicLandingpageElementsEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge */
  readonly node?: Maybe<DynamicLandingpageElementsUnion>;
};

export type DynamicLandingpageElementsUnion = BenefitsElementType | CtaElementType | FaqElementType | FactsElementType | JobSearchElementType | LinkListElementType | ListElementType | LocationElementType | MediaElementType | MoreInfoElementType | ProcessElementType | RequirementsElementType | SalaryElementType | SeparatorElementType | TabsElementType | TextElementType;

export type ErrorType = {
  readonly __typename?: 'ErrorType';
  readonly field: Scalars['String'];
  readonly messages: ReadonlyArray<Scalars['String']>;
};

export type FaqElementItemType = {
  readonly __typename?: 'FAQElementItemType';
  readonly faqElement: FaqElementType;
  readonly id: Scalars['ID'];
  readonly text: Scalars['String'];
  readonly title: Scalars['String'];
};

export type FaqElementType = {
  readonly __typename?: 'FAQElementType';
  readonly faqelementitemSet: ReadonlyArray<FaqElementItemType>;
  readonly id: Scalars['ID'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly title: Scalars['String'];
};

export type FactsElementItemType = {
  readonly __typename?: 'FactsElementItemType';
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly description: Scalars['String'];
  readonly factsElement: FactsElementType;
  readonly icon?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly title: Scalars['String'];
};

export type FactsElementType = {
  readonly __typename?: 'FactsElementType';
  readonly factselementitemSet: ReadonlyArray<FactsElementItemType>;
  readonly id: Scalars['ID'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly title: Scalars['String'];
};

export type FormFieldType = {
  readonly __typename?: 'FormFieldType';
  readonly defaultValue?: Maybe<Scalars['String']>;
  readonly fieldType?: Maybe<FormFieldTypeType>;
  readonly formfieldsSet: ReadonlyArray<FormFieldsType>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type FormFieldTypeType = {
  readonly __typename?: 'FormFieldTypeType';
  readonly formfieldSet: ReadonlyArray<FormFieldType>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type FormFieldsType = {
  readonly __typename?: 'FormFieldsType';
  readonly column: Scalars['Int'];
  readonly field: FormFieldType;
  readonly form: FormType;
  readonly id: Scalars['ID'];
  readonly required: Scalars['Boolean'];
  readonly row: Scalars['Int'];
};

export type FormOptionType = {
  readonly __typename?: 'FormOptionType';
  readonly formoptionsSet: ReadonlyArray<FormOptionsType>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type FormOptionsType = {
  readonly __typename?: 'FormOptionsType';
  readonly form: FormType;
  readonly id: Scalars['ID'];
  readonly option: FormOptionType;
  readonly value: Scalars['Boolean'];
};

export type FormType = {
  readonly __typename?: 'FormType';
  readonly formfieldsSet: ReadonlyArray<FormFieldsType>;
  readonly formoptionsSet: ReadonlyArray<FormOptionsType>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type GroupType = {
  readonly __typename?: 'GroupType';
  readonly aboutUs?: Maybe<Scalars['String']>;
  readonly aboutUsPermanent: Scalars['String'];
  readonly aboutUsTemporary: Scalars['String'];
  readonly elements?: Maybe<DynamicLandingpageElementsConnection>;
  readonly id: Scalars['ID'];
  readonly kldbNumber: Scalars['String'];
  readonly name: Scalars['String'];
  readonly ogDescription: Scalars['String'];
  readonly ogImage?: Maybe<Scalars['String']>;
};


export type GroupTypeElementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type IndustryLandingpageLocationsApplicationType = {
  readonly __typename?: 'IndustryLandingpageLocationsApplicationType';
  readonly id: Scalars['ID'];
  readonly industryLandingpage: LandingpageIndustryType;
  readonly name: Scalars['String'];
  readonly sid?: Maybe<Scalars['String']>;
};

export type IndustryLocationElementType = {
  readonly __typename?: 'IndustryLocationElementType';
  readonly id: Scalars['ID'];
  readonly industryLandingpage: LandingpageIndustryType;
  readonly slug: Scalars['String'];
  readonly title: Scalars['String'];
};

export type IndustryLogoType = {
  readonly __typename?: 'IndustryLogoType';
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly id: Scalars['ID'];
  readonly industryLandingpage: LandingpageIndustryType;
  readonly industryLogo?: Maybe<Scalars['String']>;
};

export type JobAdDistanceType = {
  readonly __typename?: 'JobAdDistanceType';
  readonly adId?: Maybe<Scalars['String']>;
  readonly additionalLocations?: Maybe<ReadonlyArray<Maybe<LocationType>>>;
  readonly applicationType?: Maybe<Scalars['String']>;
  readonly ats: JobadsJobDescriptionAtsChoices;
  readonly baseSalaryCurrency?: Maybe<Scalars['String']>;
  readonly baseSalaryMax?: Maybe<Scalars['Float']>;
  readonly baseSalaryMin?: Maybe<Scalars['Float']>;
  readonly baseSalaryPubExternally?: Maybe<Scalars['Boolean']>;
  readonly baseSalaryUnit?: Maybe<Scalars['String']>;
  readonly benefits?: Maybe<Scalars['String']>;
  readonly benefitsTitle?: Maybe<Scalars['String']>;
  readonly bfaAccountId?: Maybe<Scalars['String']>;
  readonly bfaApplicationMethod?: Maybe<Scalars['String']>;
  readonly bfaCollectiveAgreement?: Maybe<Scalars['Boolean']>;
  readonly bfaCollectiveAgreementName?: Maybe<Scalars['String']>;
  readonly bfaPlacementOrder?: Maybe<Scalars['String']>;
  readonly bfaSocialInsurance?: Maybe<Scalars['String']>;
  readonly branchId?: Maybe<Scalars['String']>;
  readonly careerStage?: Maybe<Scalars['String']>;
  readonly clientLogo?: Maybe<Scalars['String']>;
  readonly clientLogoImage?: Maybe<Scalars['String']>;
  readonly closingText?: Maybe<Scalars['String']>;
  readonly closingTextTitle?: Maybe<Scalars['String']>;
  readonly contactCity?: Maybe<Scalars['String']>;
  readonly contactCompany?: Maybe<Scalars['String']>;
  readonly contactMail?: Maybe<Scalars['String']>;
  readonly contactName?: Maybe<Scalars['String']>;
  readonly contactPhone?: Maybe<Scalars['String']>;
  readonly contactResponsible?: Maybe<Scalars['String']>;
  readonly contactSex?: Maybe<Scalars['Int']>;
  readonly contactStreet?: Maybe<Scalars['String']>;
  readonly contactZip?: Maybe<Scalars['String']>;
  readonly costcenter?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly cvMandatory?: Maybe<Scalars['Boolean']>;
  readonly distance?: Maybe<Scalars['Float']>;
  readonly education?: Maybe<Scalars['String']>;
  readonly employmentType?: Maybe<Scalars['String']>;
  readonly estimatedEndDate?: Maybe<Scalars['DateTime']>;
  readonly estimatedStartDate?: Maybe<Scalars['DateTime']>;
  readonly function?: Maybe<Scalars['String']>;
  readonly headerImage?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly industry?: Maybe<Scalars['String']>;
  readonly introText?: Maybe<Scalars['String']>;
  readonly jobId?: Maybe<Scalars['String']>;
  readonly jobLocation?: Maybe<Scalars['String']>;
  readonly jobRegion?: Maybe<Scalars['String']>;
  readonly jobZipCode?: Maybe<Scalars['String']>;
  readonly jobadlocationSet: ReadonlyArray<LocationType>;
  readonly keywords?: Maybe<Scalars['String']>;
  readonly kldbNumber?: Maybe<Scalars['String']>;
  readonly language: Scalars['String'];
  readonly managementExperience?: Maybe<Scalars['String']>;
  readonly mandant?: Maybe<Scalars['String']>;
  readonly medationType?: Maybe<Scalars['String']>;
  readonly nationWide?: Maybe<Scalars['Boolean']>;
  readonly numberOfJobopenings?: Maybe<Scalars['Int']>;
  readonly occupation?: Maybe<Scalars['String']>;
  readonly occupationArea?: Maybe<Scalars['String']>;
  readonly occupationGroup?: Maybe<Scalars['String']>;
  readonly occupationMainGroup?: Maybe<Scalars['String']>;
  readonly occupationSubGroup?: Maybe<Scalars['String']>;
  readonly occupationalType?: Maybe<Scalars['String']>;
  readonly officeId?: Maybe<Scalars['String']>;
  readonly offline?: Maybe<Scalars['DateTime']>;
  readonly offlineDate?: Maybe<Scalars['String']>;
  readonly online?: Maybe<Scalars['DateTime']>;
  readonly onlineDate?: Maybe<Scalars['String']>;
  readonly organizationCompany?: Maybe<Scalars['String']>;
  readonly organizationLogo?: Maybe<Scalars['String']>;
  readonly organizationWebsite?: Maybe<Scalars['String']>;
  readonly placementType?: Maybe<Scalars['String']>;
  readonly qualifications?: Maybe<Scalars['String']>;
  readonly qualificationsTitle?: Maybe<Scalars['String']>;
  readonly referenceNumber: Scalars['String'];
  readonly remoteOption?: Maybe<Scalars['String']>;
  readonly responsibilities?: Maybe<Scalars['String']>;
  readonly responsibilitiesTitle?: Maybe<Scalars['String']>;
  readonly schaltungsId?: Maybe<Scalars['String']>;
  readonly sector?: Maybe<Scalars['String']>;
  readonly sourceAdId?: Maybe<Scalars['String']>;
  readonly sourceJobId?: Maybe<Scalars['String']>;
  readonly sourceName?: Maybe<Scalars['String']>;
  readonly synonyms?: Maybe<Scalars['String']>;
  readonly title?: Maybe<Scalars['String']>;
  readonly uploadedBy?: Maybe<Scalars['String']>;
  readonly workExperiences?: Maybe<Scalars['String']>;
  readonly workHours?: Maybe<Scalars['String']>;
};

export type JobAdType = {
  readonly __typename?: 'JobAdType';
  readonly adId?: Maybe<Scalars['String']>;
  readonly additionalLocations?: Maybe<ReadonlyArray<Maybe<LocationType>>>;
  readonly applicationType?: Maybe<Scalars['String']>;
  readonly ats: JobadsJobDescriptionAtsChoices;
  readonly baseSalaryCurrency?: Maybe<Scalars['String']>;
  readonly baseSalaryMax?: Maybe<Scalars['Float']>;
  readonly baseSalaryMin?: Maybe<Scalars['Float']>;
  readonly baseSalaryPubExternally?: Maybe<Scalars['Boolean']>;
  readonly baseSalaryUnit?: Maybe<Scalars['String']>;
  readonly benefits?: Maybe<Scalars['String']>;
  readonly benefitsTitle?: Maybe<Scalars['String']>;
  readonly bfaAccountId?: Maybe<Scalars['String']>;
  readonly bfaApplicationMethod?: Maybe<Scalars['String']>;
  readonly bfaCollectiveAgreement?: Maybe<Scalars['Boolean']>;
  readonly bfaCollectiveAgreementName?: Maybe<Scalars['String']>;
  readonly bfaPlacementOrder?: Maybe<Scalars['String']>;
  readonly bfaSocialInsurance?: Maybe<Scalars['String']>;
  readonly branchId?: Maybe<Scalars['String']>;
  readonly careerStage?: Maybe<Scalars['String']>;
  readonly clientLogo?: Maybe<Scalars['String']>;
  readonly clientLogoImage?: Maybe<Scalars['String']>;
  readonly closingText?: Maybe<Scalars['String']>;
  readonly closingTextTitle?: Maybe<Scalars['String']>;
  readonly contactCity?: Maybe<Scalars['String']>;
  readonly contactCompany?: Maybe<Scalars['String']>;
  readonly contactMail?: Maybe<Scalars['String']>;
  readonly contactName?: Maybe<Scalars['String']>;
  readonly contactPhone?: Maybe<Scalars['String']>;
  readonly contactResponsible?: Maybe<Scalars['String']>;
  readonly contactSex?: Maybe<Scalars['Int']>;
  readonly contactStreet?: Maybe<Scalars['String']>;
  readonly contactZip?: Maybe<Scalars['String']>;
  readonly costcenter?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly cvMandatory?: Maybe<Scalars['Boolean']>;
  readonly education?: Maybe<Scalars['String']>;
  readonly employmentType?: Maybe<Scalars['String']>;
  readonly estimatedEndDate?: Maybe<Scalars['DateTime']>;
  readonly estimatedStartDate?: Maybe<Scalars['DateTime']>;
  readonly function?: Maybe<Scalars['String']>;
  readonly group?: Maybe<GroupType>;
  readonly headerImage?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly industry?: Maybe<Scalars['String']>;
  readonly introText?: Maybe<Scalars['String']>;
  readonly jobId?: Maybe<Scalars['String']>;
  readonly jobLocation?: Maybe<Scalars['String']>;
  readonly jobRegion?: Maybe<Scalars['String']>;
  readonly jobZipCode?: Maybe<Scalars['String']>;
  readonly jobadlocationSet: ReadonlyArray<LocationType>;
  readonly keywords?: Maybe<Scalars['String']>;
  readonly kldbNumber?: Maybe<Scalars['String']>;
  readonly language: Scalars['String'];
  readonly managementExperience?: Maybe<Scalars['String']>;
  readonly mandant?: Maybe<Scalars['String']>;
  readonly medationType?: Maybe<Scalars['String']>;
  readonly nationWide?: Maybe<Scalars['Boolean']>;
  readonly numberOfJobopenings?: Maybe<Scalars['Int']>;
  readonly occupation?: Maybe<Scalars['String']>;
  readonly occupationArea?: Maybe<Scalars['String']>;
  readonly occupationGroup?: Maybe<Scalars['String']>;
  readonly occupationMainGroup?: Maybe<Scalars['String']>;
  readonly occupationSubGroup?: Maybe<Scalars['String']>;
  readonly occupationalType?: Maybe<Scalars['String']>;
  readonly officeId?: Maybe<Scalars['String']>;
  readonly offline?: Maybe<Scalars['DateTime']>;
  readonly offlineDate?: Maybe<Scalars['String']>;
  readonly online?: Maybe<Scalars['DateTime']>;
  readonly onlineDate?: Maybe<Scalars['String']>;
  readonly organizationCompany?: Maybe<Scalars['String']>;
  readonly organizationLogo?: Maybe<Scalars['String']>;
  readonly organizationWebsite?: Maybe<Scalars['String']>;
  readonly placementType?: Maybe<Scalars['String']>;
  readonly qualifications?: Maybe<Scalars['String']>;
  readonly qualificationsTitle?: Maybe<Scalars['String']>;
  readonly referenceNumber: Scalars['String'];
  readonly remoteOption?: Maybe<Scalars['String']>;
  readonly responsibilities?: Maybe<Scalars['String']>;
  readonly responsibilitiesTitle?: Maybe<Scalars['String']>;
  readonly schaltungsId?: Maybe<Scalars['String']>;
  readonly sector?: Maybe<Scalars['String']>;
  readonly sourceAdId?: Maybe<Scalars['String']>;
  readonly sourceJobId?: Maybe<Scalars['String']>;
  readonly sourceName?: Maybe<Scalars['String']>;
  readonly synonyms?: Maybe<Scalars['String']>;
  readonly title?: Maybe<Scalars['String']>;
  readonly uploadedBy?: Maybe<Scalars['String']>;
  readonly whatsappAvailable?: Maybe<Scalars['Boolean']>;
  readonly workExperiences?: Maybe<Scalars['String']>;
  readonly workHours?: Maybe<Scalars['String']>;
};

export type JobGroupType = {
  readonly __typename?: 'JobGroupType';
  readonly count?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly jobads?: Maybe<ReadonlyArray<Maybe<JobAdType>>>;
  readonly kldbNumber: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};

export type JobSearchElementItemType = {
  readonly __typename?: 'JobSearchElementItemType';
  readonly id: Scalars['ID'];
  readonly jobSearchElement: JobSearchElementType;
  readonly jobadsGroupId: Scalars['String'];
};

export type JobSearchElementType = {
  readonly __typename?: 'JobSearchElementType';
  readonly id: Scalars['ID'];
  readonly jobadsDistance: Scalars['Int'];
  readonly jobsearchelementitemSet: ReadonlyArray<JobSearchElementItemType>;
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly title: Scalars['String'];
};

/** An enumeration. */
export enum JobadsJobDescriptionAtsChoices {
  /** Ers */
  ERS = 'ERS',
  /** Info */
  INFO = 'INFO',
  /** Not Found */
  NOT_FOUND = 'NOT_FOUND'
}

export type KldbLandingpageLocationsApplicationType = {
  readonly __typename?: 'KldbLandingpageLocationsApplicationType';
  readonly id: Scalars['ID'];
  readonly kldbLandingpage: LandingpageKldbType;
  readonly name: Scalars['String'];
  readonly sid?: Maybe<Scalars['String']>;
};

export type LandingpageBrandedType = {
  readonly __typename?: 'LandingpageBrandedType';
  readonly brand?: Maybe<Scalars['String']>;
  readonly brandedlandingpagelocationsSet: ReadonlyArray<BrandedLocationElementType>;
  readonly brandedlandingpagelocationsapplicationSet: ReadonlyArray<BrandedLandingpageLocationsApplicationType>;
  readonly brandedlandingpagelogoSet: ReadonlyArray<BrandedLogoType>;
  readonly bubbleText?: Maybe<Scalars['String']>;
  readonly buzzwords?: Maybe<Scalars['String']>;
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly color?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly description: Scalars['String'];
  readonly elements?: Maybe<DynamicLandingpageElementsConnection>;
  readonly form?: Maybe<FormType>;
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly jobPostingId?: Maybe<Scalars['String']>;
  readonly kldb: Scalars['String'];
  readonly locationLinksTitle: Scalars['String'];
  readonly online: Scalars['Boolean'];
  readonly recommendedBy: Scalars['String'];
  /** SId or Businessline */
  readonly sid?: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly subline: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly utmCampaignId?: Maybe<Scalars['String']>;
  readonly withJobProposals: Scalars['Boolean'];
};


export type LandingpageBrandedTypeElementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type LandingpageClientType = {
  readonly __typename?: 'LandingpageClientType';
  readonly brand?: Maybe<Scalars['String']>;
  readonly bubbleText?: Maybe<Scalars['String']>;
  readonly buzzwords?: Maybe<Scalars['String']>;
  readonly clientlandingpagelocationsSet: ReadonlyArray<ClientLandingpageLocationsType>;
  readonly clientlandingpagelocationsapplicationSet: ReadonlyArray<ClientLandingpageLocationsApplicationType>;
  readonly clientlandingpagelogoSet: ReadonlyArray<LogoType>;
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly color?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly description: Scalars['String'];
  readonly elements?: Maybe<DynamicLandingpageElementsConnection>;
  readonly form?: Maybe<FormType>;
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly jobPostingId?: Maybe<Scalars['String']>;
  readonly kldb: Scalars['String'];
  readonly locationLinksTitle: Scalars['String'];
  readonly online: Scalars['Boolean'];
  readonly recommendedBy: Scalars['String'];
  /** SId or Businessline */
  readonly sid?: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly subline: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly utmCampaignId?: Maybe<Scalars['String']>;
  readonly withJobProposals: Scalars['Boolean'];
};


export type LandingpageClientTypeElementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type LandingpageIndustryType = {
  readonly __typename?: 'LandingpageIndustryType';
  readonly brand?: Maybe<Scalars['String']>;
  readonly bubbleText?: Maybe<Scalars['String']>;
  readonly buzzwords?: Maybe<Scalars['String']>;
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly color?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly description: Scalars['String'];
  readonly elements?: Maybe<DynamicLandingpageElementsConnection>;
  readonly form?: Maybe<FormType>;
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly industrylandingpagelocationsSet: ReadonlyArray<IndustryLocationElementType>;
  readonly industrylandingpagelocationsapplicationSet: ReadonlyArray<IndustryLandingpageLocationsApplicationType>;
  readonly industrylandingpagelogoSet: ReadonlyArray<IndustryLogoType>;
  readonly jobPostingId?: Maybe<Scalars['String']>;
  readonly kldb: Scalars['String'];
  readonly locationLinksTitle: Scalars['String'];
  readonly online: Scalars['Boolean'];
  readonly recommendedBy: Scalars['String'];
  /** SId or Businessline */
  readonly sid?: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly subline: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly utmCampaignId?: Maybe<Scalars['String']>;
  readonly withJobProposals: Scalars['Boolean'];
};


export type LandingpageIndustryTypeElementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type LandingpageKldbType = {
  readonly __typename?: 'LandingpageKLDBType';
  readonly buzzwords?: Maybe<Scalars['String']>;
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly createdAt: Scalars['DateTime'];
  readonly description: Scalars['String'];
  readonly elements?: Maybe<DynamicLandingpageElementsConnection>;
  readonly form?: Maybe<FormType>;
  readonly formType: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly jobPostingId?: Maybe<Scalars['String']>;
  readonly kldb: Scalars['String'];
  readonly kldblandingpagelocationsapplicationSet: ReadonlyArray<KldbLandingpageLocationsApplicationType>;
  readonly online: Scalars['Boolean'];
  /** SId or Businessline */
  readonly sid?: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly subline: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly utmCampaignId?: Maybe<Scalars['String']>;
  readonly varType: Scalars['String'];
  readonly withJobProposals: Scalars['Boolean'];
};


export type LandingpageKldbTypeElementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type LanguageTranslationType = {
  readonly __typename?: 'LanguageTranslationType';
  readonly language?: Maybe<Scalars['String']>;
  readonly translations?: Maybe<ReadonlyArray<Maybe<TranslationType>>>;
};

export type LinkListElementItemType = {
  readonly __typename?: 'LinkListElementItemType';
  readonly id: Scalars['ID'];
  readonly linkListElement: LinkListElementType;
  readonly linkTitle: Scalars['String'];
  readonly linkUrl: Scalars['String'];
  readonly target?: Maybe<Scalars['String']>;
};

export type LinkListElementType = {
  readonly __typename?: 'LinkListElementType';
  readonly hideTitle: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly linklistelementitemSet: ReadonlyArray<LinkListElementItemType>;
  readonly optionalTitle?: Maybe<Scalars['String']>;
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
};

export type ListElementItemType = {
  readonly __typename?: 'ListElementItemType';
  readonly id: Scalars['ID'];
  readonly itemText: Scalars['String'];
  readonly listElement: ListElementType;
};

export type ListElementType = {
  readonly __typename?: 'ListElementType';
  readonly id: Scalars['ID'];
  readonly listelementitemSet: ReadonlyArray<ListElementItemType>;
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly title: Scalars['String'];
};

export type LocationElementItemType = {
  readonly __typename?: 'LocationElementItemType';
  readonly id: Scalars['ID'];
  readonly locationElement: LocationElementType;
  readonly slug: Scalars['String'];
  readonly text: Scalars['String'];
  readonly title: Scalars['String'];
};

export type LocationElementType = {
  readonly __typename?: 'LocationElementType';
  readonly id: Scalars['ID'];
  readonly locationelementitemSet: ReadonlyArray<LocationElementItemType>;
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly title: Scalars['String'];
};

export type LocationType = {
  readonly __typename?: 'LocationType';
  readonly country?: Maybe<Scalars['String']>;
  readonly countryCode?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly isMainLocation: Scalars['Boolean'];
  readonly jobad: JobAdDistanceType;
  readonly location?: Maybe<Scalars['String']>;
  readonly region?: Maybe<Scalars['String']>;
  readonly zipCode?: Maybe<Scalars['String']>;
};

export type LogoType = {
  readonly __typename?: 'LogoType';
  readonly clientLandingpage: LandingpageClientType;
  readonly clientLogo?: Maybe<Scalars['String']>;
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly id: Scalars['ID'];
};

export type MediaElementType = {
  readonly __typename?: 'MediaElementType';
  readonly aboveLine?: Maybe<Scalars['String']>;
  readonly buttonLink?: Maybe<Scalars['String']>;
  readonly buttonText?: Maybe<Scalars['String']>;
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly id: Scalars['ID'];
  readonly mediaFile?: Maybe<Scalars['String']>;
  readonly mediaPosition: Scalars['String'];
  readonly mediaSrc?: Maybe<Scalars['String']>;
  readonly mediaText: Scalars['String'];
  readonly mediaType: Scalars['String'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly title: Scalars['String'];
};

export type MoreInfoElementItemType = {
  readonly __typename?: 'MoreInfoElementItemType';
  readonly buttonText: Scalars['String'];
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly link: Scalars['String'];
  readonly moreInfoElement: MoreInfoElementType;
  readonly title: Scalars['String'];
};

export type MoreInfoElementType = {
  readonly __typename?: 'MoreInfoElementType';
  readonly id: Scalars['ID'];
  readonly moreinfoelementitemSet: ReadonlyArray<MoreInfoElementItemType>;
  readonly optionalText?: Maybe<Scalars['String']>;
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly title: Scalars['String'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly createApplication?: Maybe<CreateApplicationMutationPayload>;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationMutationInput;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']>;
};

export type ProcessElementItemType = {
  readonly __typename?: 'ProcessElementItemType';
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly processElement: ProcessElementType;
  readonly title: Scalars['String'];
};

export type ProcessElementType = {
  readonly __typename?: 'ProcessElementType';
  readonly id: Scalars['ID'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly processelementitemSet: ReadonlyArray<ProcessElementItemType>;
  readonly sort: Scalars['String'];
  readonly subline?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly withNumbers: Scalars['Boolean'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly branchesForProActiveApplications?: Maybe<ReadonlyArray<Maybe<BranchType>>>;
  readonly form?: Maybe<FormType>;
  readonly frontendConfigurations?: Maybe<ReadonlyArray<Maybe<ConfigurationType>>>;
  readonly frontendTranslations?: Maybe<ReadonlyArray<Maybe<LanguageTranslationType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<GroupType>>>;
  readonly jobad?: Maybe<JobAdType>;
  readonly jobads?: Maybe<ReadonlyArray<Maybe<JobAdType>>>;
  readonly jobadsByDistance?: Maybe<ReadonlyArray<Maybe<JobAdDistanceType>>>;
  readonly jobgroup?: Maybe<JobGroupType>;
  readonly landingpageBranded?: Maybe<LandingpageBrandedType>;
  readonly landingpageClient?: Maybe<LandingpageClientType>;
  readonly landingpageIndustry?: Maybe<LandingpageIndustryType>;
  readonly landingpageKldb?: Maybe<LandingpageKldbType>;
  readonly recoTeasers?: Maybe<ReadonlyArray<Maybe<RecoTeaserType>>>;
  readonly thankyouTeasers?: Maybe<ReadonlyArray<Maybe<ThankYouTeaserType>>>;
};


export type QueryBranchesForProActiveApplicationsArgs = {
  tenantId: Scalars['Int'];
};


export type QueryFormArgs = {
  countryCode: Scalars['String'];
  name: Scalars['String'];
};


export type QueryFrontendConfigurationsArgs = {
  countryCode: Scalars['String'];
};


export type QueryFrontendTranslationsArgs = {
  languages?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type QueryGroupsArgs = {
  countryCode: Scalars['String'];
  employmentType: Scalars['Int'];
};


export type QueryJobadArgs = {
  countryCode: Scalars['String'];
  sourceAdId: Scalars['String'];
};


export type QueryJobadsArgs = {
  countryCode: Scalars['String'];
  kldbNumber?: InputMaybe<Scalars['String']>;
};


export type QueryJobadsByDistanceArgs = {
  countryCode: Scalars['String'];
  distance?: InputMaybe<Scalars['Int']>;
  kldbNumbers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  plz: Scalars['String'];
};


export type QueryJobgroupArgs = {
  countryCode: Scalars['String'];
  kldbNumber: Scalars['String'];
};


export type QueryLandingpageBrandedArgs = {
  countryCode: Scalars['String'];
  secret?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryLandingpageClientArgs = {
  countryCode: Scalars['String'];
  secret?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryLandingpageIndustryArgs = {
  countryCode: Scalars['String'];
  secret?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryLandingpageKldbArgs = {
  countryCode: Scalars['String'];
  secret?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryRecoTeasersArgs = {
  countryCode: Scalars['String'];
};


export type QueryThankyouTeasersArgs = {
  countryCode: Scalars['String'];
};

export type RecoTeaserType = {
  readonly __typename?: 'RecoTeaserType';
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly link: Scalars['String'];
  readonly linkText: Scalars['String'];
  readonly order: Scalars['Int'];
  readonly subline: Scalars['String'];
  readonly title: Scalars['String'];
};

export type RequirementsElementItemType = {
  readonly __typename?: 'RequirementsElementItemType';
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly requirementsElement: RequirementsElementType;
  readonly title: Scalars['String'];
};

export type RequirementsElementType = {
  readonly __typename?: 'RequirementsElementType';
  readonly id: Scalars['ID'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly requirementselementitemSet: ReadonlyArray<RequirementsElementItemType>;
  readonly sort: Scalars['String'];
  readonly subline?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type SalaryElementType = {
  readonly __typename?: 'SalaryElementType';
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly max: Scalars['Int'];
  readonly min: Scalars['Int'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly subline?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type SeparatorElementType = {
  readonly __typename?: 'SeparatorElementType';
  readonly id: Scalars['ID'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly title: Scalars['String'];
};

export type TabsElementItemType = {
  readonly __typename?: 'TabsElementItemType';
  readonly content: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly linkUrl?: Maybe<Scalars['String']>;
  readonly tabsElement: TabsElementType;
  readonly title: Scalars['String'];
};

export type TabsElementType = {
  readonly __typename?: 'TabsElementType';
  readonly id: Scalars['ID'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly tabsSubline: Scalars['String'];
  readonly tabselementitemSet: ReadonlyArray<TabsElementItemType>;
  readonly title: Scalars['String'];
};

export type TextElementType = {
  readonly __typename?: 'TextElementType';
  readonly id: Scalars['ID'];
  readonly order?: Maybe<Scalars['Int']>;
  readonly sort: Scalars['String'];
  readonly subline?: Maybe<Scalars['String']>;
  readonly text: Scalars['String'];
  readonly title: Scalars['String'];
};

export type ThankYouTeaserType = {
  readonly __typename?: 'ThankYouTeaserType';
  readonly cloudinaryImage?: Maybe<CloudinaryImageType>;
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly image?: Maybe<Scalars['String']>;
  readonly link: Scalars['String'];
  readonly linkText: Scalars['String'];
  readonly order: Scalars['Int'];
  readonly title: Scalars['String'];
};

export type TranslationType = {
  readonly __typename?: 'TranslationType';
  readonly key?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['String']>;
};

export type ElementsFragmentFragment = { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> };

export type FormFragmentFragment = { readonly __typename?: 'FormType', readonly id: string, readonly name: string, readonly formfieldsSet: ReadonlyArray<{ readonly __typename?: 'FormFieldsType', readonly required: boolean, readonly row: number, readonly column: number, readonly field: { readonly __typename?: 'FormFieldType', readonly name: string, readonly defaultValue?: string | undefined, readonly fieldType?: { readonly __typename?: 'FormFieldTypeType', readonly name: string } | undefined } }>, readonly formoptionsSet: ReadonlyArray<{ readonly __typename?: 'FormOptionsType', readonly value: boolean, readonly option: { readonly __typename?: 'FormOptionType', readonly name: string } }> };

export type JobBaseInfoFragment = { readonly __typename?: 'JobAdType', readonly title?: string | undefined, readonly onlineDate?: string | undefined, readonly employmentType?: string | undefined, readonly placementType?: string | undefined, readonly workHours?: string | undefined, readonly jobLocation?: string | undefined, readonly officeId?: string | undefined, readonly sourceJobId?: string | undefined, readonly industry?: string | undefined, readonly occupation?: string | undefined, readonly occupationMainGroup?: string | undefined, readonly kldbNumber?: string | undefined, readonly cvMandatory?: boolean | undefined, readonly branchId?: string | undefined };

export type LandingBrandedFragmentFragment = { readonly __typename?: 'LandingpageBrandedType', readonly id: string, readonly title: string, readonly sid?: string | undefined, readonly online: boolean, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly slug: string, readonly brand?: string | undefined, readonly kldb: string, readonly color?: string | undefined, readonly bubbleText?: string | undefined, readonly buzzwords?: string | undefined, readonly jobPostingId?: string | undefined, readonly utmCampaignId?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined, readonly form?: { readonly __typename?: 'FormType', readonly id: string, readonly name: string, readonly formfieldsSet: ReadonlyArray<{ readonly __typename?: 'FormFieldsType', readonly required: boolean, readonly row: number, readonly column: number, readonly field: { readonly __typename?: 'FormFieldType', readonly name: string, readonly defaultValue?: string | undefined, readonly fieldType?: { readonly __typename?: 'FormFieldTypeType', readonly name: string } | undefined } }>, readonly formoptionsSet: ReadonlyArray<{ readonly __typename?: 'FormOptionsType', readonly value: boolean, readonly option: { readonly __typename?: 'FormOptionType', readonly name: string } }> } | undefined, readonly brandedlandingpagelogoSet: ReadonlyArray<{ readonly __typename?: 'BrandedLogoType', readonly brandedLogo?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }>, readonly brandedlandingpagelocationsSet: ReadonlyArray<{ readonly __typename?: 'BrandedLocationElementType', readonly title: string, readonly slug: string }>, readonly brandedlandingpagelocationsapplicationSet: ReadonlyArray<{ readonly __typename?: 'BrandedLandingpageLocationsApplicationType', readonly id: string, readonly name: string, readonly sid?: string | undefined }> };

export type LandingPageClientFragmentFragment = { readonly __typename?: 'LandingpageClientType', readonly id: string, readonly sid?: string | undefined, readonly title: string, readonly online: boolean, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly slug: string, readonly brand?: string | undefined, readonly kldb: string, readonly color?: string | undefined, readonly bubbleText?: string | undefined, readonly locationLinksTitle: string, readonly buzzwords?: string | undefined, readonly withJobProposals: boolean, readonly jobPostingId?: string | undefined, readonly utmCampaignId?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly clientlandingpagelogoSet: ReadonlyArray<{ readonly __typename?: 'LogoType', readonly clientLogo?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }>, readonly clientlandingpagelocationsSet: ReadonlyArray<{ readonly __typename?: 'ClientLandingpageLocationsType', readonly title: string, readonly slug: string }>, readonly clientlandingpagelocationsapplicationSet: ReadonlyArray<{ readonly __typename?: 'ClientLandingpageLocationsApplicationType', readonly id: string, readonly name: string, readonly sid?: string | undefined }>, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined, readonly form?: { readonly __typename?: 'FormType', readonly id: string, readonly name: string, readonly formfieldsSet: ReadonlyArray<{ readonly __typename?: 'FormFieldsType', readonly required: boolean, readonly row: number, readonly column: number, readonly field: { readonly __typename?: 'FormFieldType', readonly name: string, readonly defaultValue?: string | undefined, readonly fieldType?: { readonly __typename?: 'FormFieldTypeType', readonly name: string } | undefined } }>, readonly formoptionsSet: ReadonlyArray<{ readonly __typename?: 'FormOptionsType', readonly value: boolean, readonly option: { readonly __typename?: 'FormOptionType', readonly name: string } }> } | undefined };

export type LandingPageIndustryFragmentFragment = { readonly __typename?: 'LandingpageIndustryType', readonly id: string, readonly title: string, readonly online: boolean, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly buzzwords?: string | undefined, readonly sid?: string | undefined, readonly kldb: string, readonly color?: string | undefined, readonly bubbleText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined, readonly industrylandingpagelogoSet: ReadonlyArray<{ readonly __typename?: 'IndustryLogoType', readonly industryLogo?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> };

export type LandingPageKldbFragmentFragment = { readonly __typename?: 'LandingpageKLDBType', readonly id: string, readonly title: string, readonly online: boolean, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly buzzwords?: string | undefined, readonly sid?: string | undefined, readonly kldb: string, readonly formType: number, readonly withJobProposals: boolean, readonly jobPostingId?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly form?: { readonly __typename?: 'FormType', readonly id: string, readonly name: string, readonly formfieldsSet: ReadonlyArray<{ readonly __typename?: 'FormFieldsType', readonly required: boolean, readonly row: number, readonly column: number, readonly field: { readonly __typename?: 'FormFieldType', readonly name: string, readonly defaultValue?: string | undefined, readonly fieldType?: { readonly __typename?: 'FormFieldTypeType', readonly name: string } | undefined } }>, readonly formoptionsSet: ReadonlyArray<{ readonly __typename?: 'FormOptionsType', readonly value: boolean, readonly option: { readonly __typename?: 'FormOptionType', readonly name: string } }> } | undefined, readonly kldblandingpagelocationsapplicationSet: ReadonlyArray<{ readonly __typename?: 'KldbLandingpageLocationsApplicationType', readonly id: string, readonly name: string, readonly sid?: string | undefined }>, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined };

export type RecoTeaserFragmentFragment = { readonly __typename?: 'RecoTeaserType', readonly title: string, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined };

export type ThankYouTeaserFragmentFragment = { readonly __typename?: 'ThankYouTeaserType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined };

export type CreateAppMutationVariables = Exact<{
  fileCv?: InputMaybe<Scalars['Upload']>;
  fileOthers?: InputMaybe<Scalars['Upload']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  street: Scalars['String'];
  number: Scalars['String'];
  zipcode: Scalars['String'];
  city: Scalars['String'];
  phone: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  email: Scalars['String'];
  jobId?: InputMaybe<Scalars['String']>;
  greeting?: InputMaybe<Scalars['String']>;
  desiredPosition?: InputMaybe<Scalars['String']>;
  desiredJobLocation?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  varSource?: InputMaybe<Scalars['String']>;
  varCampaign?: InputMaybe<Scalars['String']>;
  varContent?: InputMaybe<Scalars['String']>;
  varMedium?: InputMaybe<Scalars['String']>;
  sid?: InputMaybe<Scalars['String']>;
  varType: Scalars['String'];
  varTerm?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  schaltungsId?: InputMaybe<Scalars['String']>;
  above18?: InputMaybe<Scalars['Boolean']>;
  branchId?: InputMaybe<Scalars['String']>;
  isSpontaneous?: InputMaybe<Scalars['Boolean']>;
  marketingPreferencesStatus?: InputMaybe<Scalars['Boolean']>;
  marketingPreferencesType?: InputMaybe<Scalars['String']>;
  privacyConsentStatus?: InputMaybe<Scalars['Boolean']>;
  privacyConsentType?: InputMaybe<Scalars['String']>;
  privacyConsentVersion?: InputMaybe<Scalars['String']>;
  termsAndConditionsStatus?: InputMaybe<Scalars['Boolean']>;
  maxCommuteDistanceKm?: InputMaybe<Scalars['Int']>;
  numberMonthsUpdateCheck?: InputMaybe<Scalars['Int']>;
}>;


export type CreateAppMutation = { readonly __typename?: 'Mutation', readonly createApplication?: { readonly __typename?: 'CreateApplicationMutationPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | undefined> | undefined } | undefined };

export type ErrorPageQueryVariables = Exact<{
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type ErrorPageQuery = { readonly __typename?: 'Query', readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type JobLinkQueryVariables = Exact<{
  sourceAdId: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type JobLinkQuery = { readonly __typename?: 'Query', readonly jobad?: { readonly __typename?: 'JobAdType', readonly occupation?: string | undefined, readonly jobLocation?: string | undefined, readonly kldbNumber?: string | undefined, readonly sourceAdId?: string | undefined, readonly sourceJobId?: string | undefined } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type JobDetailsQueryVariables = Exact<{
  sourceAdId: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type JobDetailsQuery = { readonly __typename?: 'Query', readonly jobad?: { readonly __typename?: 'JobAdType', readonly ats: JobadsJobDescriptionAtsChoices, readonly baseSalaryCurrency?: string | undefined, readonly baseSalaryMax?: number | undefined, readonly baseSalaryMin?: number | undefined, readonly baseSalaryPubExternally?: boolean | undefined, readonly baseSalaryUnit?: string | undefined, readonly benefits?: string | undefined, readonly benefitsTitle?: string | undefined, readonly clientLogoImage?: string | undefined, readonly closingText?: string | undefined, readonly closingTextTitle?: string | undefined, readonly contactCity?: string | undefined, readonly contactMail?: string | undefined, readonly contactName?: string | undefined, readonly contactPhone?: string | undefined, readonly contactStreet?: string | undefined, readonly contactZip?: string | undefined, readonly cvMandatory?: boolean | undefined, readonly education?: string | undefined, readonly employmentType?: string | undefined, readonly industry?: string | undefined, readonly introText?: string | undefined, readonly jobLocation?: string | undefined, readonly jobRegion?: string | undefined, readonly jobZipCode?: string | undefined, readonly kldbNumber?: string | undefined, readonly medationType?: string | undefined, readonly occupation?: string | undefined, readonly occupationalType?: string | undefined, readonly occupationGroup?: string | undefined, readonly occupationMainGroup?: string | undefined, readonly offlineDate?: string | undefined, readonly onlineDate?: string | undefined, readonly placementType?: string | undefined, readonly qualifications?: string | undefined, readonly qualificationsTitle?: string | undefined, readonly responsibilities?: string | undefined, readonly responsibilitiesTitle?: string | undefined, readonly schaltungsId?: string | undefined, readonly sourceAdId?: string | undefined, readonly sourceJobId?: string | undefined, readonly title?: string | undefined, readonly workHours?: string | undefined, readonly workExperiences?: string | undefined, readonly remoteOption?: string | undefined, readonly jobadlocationSet: ReadonlyArray<{ readonly __typename?: 'LocationType', readonly isMainLocation: boolean, readonly location?: string | undefined }>, readonly group?: { readonly __typename?: 'GroupType', readonly ogDescription: string, readonly ogImage?: string | undefined, readonly aboutUs?: string | undefined, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined } | undefined } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type JobApplyQueryVariables = Exact<{
  sourceAdId: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type JobApplyQuery = { readonly __typename?: 'Query', readonly jobad?: { readonly __typename?: 'JobAdType', readonly title?: string | undefined, readonly onlineDate?: string | undefined, readonly employmentType?: string | undefined, readonly placementType?: string | undefined, readonly workHours?: string | undefined, readonly jobLocation?: string | undefined, readonly officeId?: string | undefined, readonly sourceJobId?: string | undefined, readonly sourceAdId?: string | undefined, readonly industry?: string | undefined, readonly occupation?: string | undefined, readonly occupationMainGroup?: string | undefined, readonly kldbNumber?: string | undefined, readonly cvMandatory?: boolean | undefined, readonly branchId?: string | undefined, readonly baseSalaryCurrency?: string | undefined, readonly baseSalaryMax?: number | undefined, readonly baseSalaryMin?: number | undefined, readonly baseSalaryUnit?: string | undefined, readonly benefits?: string | undefined, readonly clientLogoImage?: string | undefined, readonly closingText?: string | undefined, readonly contactCity?: string | undefined, readonly contactMail?: string | undefined, readonly contactName?: string | undefined, readonly contactPhone?: string | undefined, readonly contactSex?: number | undefined, readonly contactStreet?: string | undefined, readonly contactZip?: string | undefined, readonly education?: string | undefined, readonly introText?: string | undefined, readonly jobRegion?: string | undefined, readonly jobZipCode?: string | undefined, readonly medationType?: string | undefined, readonly occupationGroup?: string | undefined, readonly offlineDate?: string | undefined, readonly qualifications?: string | undefined, readonly responsibilities?: string | undefined, readonly schaltungsId?: string | undefined, readonly jobadlocationSet: ReadonlyArray<{ readonly __typename?: 'LocationType', readonly isMainLocation: boolean, readonly location?: string | undefined }>, readonly group?: { readonly __typename?: 'GroupType', readonly ogDescription: string, readonly ogImage?: string | undefined, readonly aboutUs?: string | undefined, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename?: 'CtaElementType' } | { readonly __typename?: 'FAQElementType' } | { readonly __typename?: 'FactsElementType' } | { readonly __typename?: 'JobSearchElementType' } | { readonly __typename?: 'LinkListElementType' } | { readonly __typename?: 'ListElementType' } | { readonly __typename?: 'LocationElementType' } | { readonly __typename?: 'MediaElementType' } | { readonly __typename?: 'MoreInfoElementType' } | { readonly __typename?: 'ProcessElementType' } | { readonly __typename?: 'RequirementsElementType' } | { readonly __typename?: 'SalaryElementType' } | { readonly __typename?: 'SeparatorElementType' } | { readonly __typename?: 'TabsElementType' } | { readonly __typename?: 'TextElementType' } | undefined } | undefined> } | undefined } | undefined } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type JobDetailsWithTeasersQueryVariables = Exact<{
  sourceAdId: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type JobDetailsWithTeasersQuery = { readonly __typename?: 'Query', readonly jobad?: { readonly __typename?: 'JobAdType', readonly employmentType?: string | undefined, readonly jobLocation?: string | undefined, readonly jobZipCode?: string | undefined, readonly kldbNumber?: string | undefined, readonly occupation?: string | undefined, readonly occupationalType?: string | undefined, readonly occupationGroup?: string | undefined, readonly occupationMainGroup?: string | undefined, readonly placementType?: string | undefined, readonly schaltungsId?: string | undefined, readonly sourceAdId?: string | undefined, readonly sourceJobId?: string | undefined, readonly title?: string | undefined, readonly workHours?: string | undefined } | undefined, readonly recoTeasers?: ReadonlyArray<{ readonly __typename?: 'RecoTeaserType', readonly title: string, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined, readonly thankyouTeasers?: ReadonlyArray<{ readonly __typename?: 'ThankYouTeaserType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type JobListQueryVariables = Exact<{
  kldbNumber: Scalars['String'];
  countryCode: Scalars['String'];
}>;


export type JobListQuery = { readonly __typename?: 'Query', readonly jobads?: ReadonlyArray<{ readonly __typename?: 'JobAdType', readonly title?: string | undefined, readonly onlineDate?: string | undefined, readonly employmentType?: string | undefined, readonly placementType?: string | undefined, readonly workHours?: string | undefined, readonly jobLocation?: string | undefined, readonly officeId?: string | undefined, readonly sourceJobId?: string | undefined, readonly industry?: string | undefined, readonly careerStage?: string | undefined, readonly occupation?: string | undefined, readonly kldbNumber?: string | undefined, readonly cvMandatory?: boolean | undefined, readonly sourceAdId?: string | undefined, readonly schaltungsId?: string | undefined } | undefined> | undefined };

export type JobGroupQueryVariables = Exact<{
  kldbNumber: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type JobGroupQuery = { readonly __typename?: 'Query', readonly jobgroup?: { readonly __typename?: 'JobGroupType', readonly id: string, readonly kldbNumber: string, readonly title: string, readonly count?: number | undefined, readonly jobads?: ReadonlyArray<{ readonly __typename?: 'JobAdType', readonly id: string, readonly title?: string | undefined, readonly onlineDate?: string | undefined, readonly employmentType?: string | undefined, readonly placementType?: string | undefined, readonly workHours?: string | undefined, readonly jobLocation?: string | undefined, readonly officeId?: string | undefined, readonly sourceJobId?: string | undefined, readonly industry?: string | undefined, readonly careerStage?: string | undefined, readonly occupation?: string | undefined, readonly kldbNumber?: string | undefined, readonly cvMandatory?: boolean | undefined, readonly sourceAdId?: string | undefined } | undefined> | undefined } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type JobsByDistanceQueryVariables = Exact<{
  plz: Scalars['String'];
  kldbNumbers: ReadonlyArray<Scalars['String']> | Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  distance?: InputMaybe<Scalars['Int']>;
  countryCode: Scalars['String'];
}>;


export type JobsByDistanceQuery = { readonly __typename?: 'Query', readonly jobadsByDistance?: ReadonlyArray<{ readonly __typename?: 'JobAdDistanceType', readonly id: string, readonly title?: string | undefined, readonly employmentType?: string | undefined, readonly jobLocation?: string | undefined, readonly onlineDate?: string | undefined, readonly sourceAdId?: string | undefined, readonly sourceJobId?: string | undefined, readonly workHours?: string | undefined, readonly schaltungsId?: string | undefined } | undefined> | undefined };

export type LandingpageBrandedSentQueryVariables = Exact<{
  slug: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  secret?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type LandingpageBrandedSentQuery = { readonly __typename?: 'Query', readonly landingpageBranded?: { readonly __typename?: 'LandingpageBrandedType', readonly kldb: string, readonly title: string, readonly brand?: string | undefined, readonly image?: string | undefined, readonly online: boolean, readonly id: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly brandedlandingpagelogoSet: ReadonlyArray<{ readonly __typename?: 'BrandedLogoType', readonly brandedLogo?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined, readonly recoTeasers?: ReadonlyArray<{ readonly __typename?: 'RecoTeaserType', readonly title: string, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined, readonly thankyouTeasers?: ReadonlyArray<{ readonly __typename?: 'ThankYouTeaserType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined };

export type LandingpageClientSentQueryVariables = Exact<{
  slug: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  secret?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type LandingpageClientSentQuery = { readonly __typename?: 'Query', readonly landingpageClient?: { readonly __typename?: 'LandingpageClientType', readonly kldb: string, readonly title: string, readonly brand?: string | undefined, readonly withJobProposals: boolean, readonly online: boolean, readonly id: string, readonly clientlandingpagelocationsapplicationSet: ReadonlyArray<{ readonly __typename?: 'ClientLandingpageLocationsApplicationType', readonly name: string }> } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined, readonly recoTeasers?: ReadonlyArray<{ readonly __typename?: 'RecoTeaserType', readonly title: string, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined, readonly thankyouTeasers?: ReadonlyArray<{ readonly __typename?: 'ThankYouTeaserType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined };

export type LandingPageKldbQueryVariables = Exact<{
  slug: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  secret?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type LandingPageKldbQuery = { readonly __typename?: 'Query', readonly landingpageKldb?: { readonly __typename?: 'LandingpageKLDBType', readonly id: string, readonly title: string, readonly online: boolean, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly buzzwords?: string | undefined, readonly sid?: string | undefined, readonly kldb: string, readonly formType: number, readonly withJobProposals: boolean, readonly jobPostingId?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly form?: { readonly __typename?: 'FormType', readonly id: string, readonly name: string, readonly formfieldsSet: ReadonlyArray<{ readonly __typename?: 'FormFieldsType', readonly required: boolean, readonly row: number, readonly column: number, readonly field: { readonly __typename?: 'FormFieldType', readonly name: string, readonly defaultValue?: string | undefined, readonly fieldType?: { readonly __typename?: 'FormFieldTypeType', readonly name: string } | undefined } }>, readonly formoptionsSet: ReadonlyArray<{ readonly __typename?: 'FormOptionsType', readonly value: boolean, readonly option: { readonly __typename?: 'FormOptionType', readonly name: string } }> } | undefined, readonly kldblandingpagelocationsapplicationSet: ReadonlyArray<{ readonly __typename?: 'KldbLandingpageLocationsApplicationType', readonly id: string, readonly name: string, readonly sid?: string | undefined }>, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type LandingPageKldbConfirmQueryVariables = Exact<{
  slug: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  secret?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type LandingPageKldbConfirmQuery = { readonly __typename?: 'Query', readonly landingpageKldb?: { readonly __typename?: 'LandingpageKLDBType', readonly id: string, readonly title: string, readonly online: boolean, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly buzzwords?: string | undefined, readonly sid?: string | undefined, readonly kldb: string, readonly formType: number, readonly withJobProposals: boolean, readonly jobPostingId?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly form?: { readonly __typename?: 'FormType', readonly id: string, readonly name: string, readonly formfieldsSet: ReadonlyArray<{ readonly __typename?: 'FormFieldsType', readonly required: boolean, readonly row: number, readonly column: number, readonly field: { readonly __typename?: 'FormFieldType', readonly name: string, readonly defaultValue?: string | undefined, readonly fieldType?: { readonly __typename?: 'FormFieldTypeType', readonly name: string } | undefined } }>, readonly formoptionsSet: ReadonlyArray<{ readonly __typename?: 'FormOptionsType', readonly value: boolean, readonly option: { readonly __typename?: 'FormOptionType', readonly name: string } }> } | undefined, readonly kldblandingpagelocationsapplicationSet: ReadonlyArray<{ readonly __typename?: 'KldbLandingpageLocationsApplicationType', readonly id: string, readonly name: string, readonly sid?: string | undefined }>, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined, readonly recoTeasers?: ReadonlyArray<{ readonly __typename?: 'RecoTeaserType', readonly title: string, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined, readonly thankyouTeasers?: ReadonlyArray<{ readonly __typename?: 'ThankYouTeaserType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined };

export type LandingPageKldbSentQueryVariables = Exact<{
  slug: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  secret?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type LandingPageKldbSentQuery = { readonly __typename?: 'Query', readonly landingpageKldb?: { readonly __typename?: 'LandingpageKLDBType', readonly kldb: string, readonly formType: number, readonly title: string, readonly withJobProposals: boolean, readonly online: boolean, readonly id: string } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined, readonly recoTeasers?: ReadonlyArray<{ readonly __typename?: 'RecoTeaserType', readonly title: string, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined, readonly thankyouTeasers?: ReadonlyArray<{ readonly __typename?: 'ThankYouTeaserType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined };

export type BrandedLandingPageQueryVariables = Exact<{
  slug: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  secret?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type BrandedLandingPageQuery = { readonly __typename?: 'Query', readonly landingpageBranded?: { readonly __typename?: 'LandingpageBrandedType', readonly id: string, readonly title: string, readonly sid?: string | undefined, readonly online: boolean, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly slug: string, readonly brand?: string | undefined, readonly kldb: string, readonly color?: string | undefined, readonly bubbleText?: string | undefined, readonly buzzwords?: string | undefined, readonly jobPostingId?: string | undefined, readonly utmCampaignId?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined, readonly form?: { readonly __typename?: 'FormType', readonly id: string, readonly name: string, readonly formfieldsSet: ReadonlyArray<{ readonly __typename?: 'FormFieldsType', readonly required: boolean, readonly row: number, readonly column: number, readonly field: { readonly __typename?: 'FormFieldType', readonly name: string, readonly defaultValue?: string | undefined, readonly fieldType?: { readonly __typename?: 'FormFieldTypeType', readonly name: string } | undefined } }>, readonly formoptionsSet: ReadonlyArray<{ readonly __typename?: 'FormOptionsType', readonly value: boolean, readonly option: { readonly __typename?: 'FormOptionType', readonly name: string } }> } | undefined, readonly brandedlandingpagelogoSet: ReadonlyArray<{ readonly __typename?: 'BrandedLogoType', readonly brandedLogo?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }>, readonly brandedlandingpagelocationsSet: ReadonlyArray<{ readonly __typename?: 'BrandedLocationElementType', readonly title: string, readonly slug: string }>, readonly brandedlandingpagelocationsapplicationSet: ReadonlyArray<{ readonly __typename?: 'BrandedLandingpageLocationsApplicationType', readonly id: string, readonly name: string, readonly sid?: string | undefined }> } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type ClientLandingPageQueryVariables = Exact<{
  slug: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  secret?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type ClientLandingPageQuery = { readonly __typename?: 'Query', readonly landingpageClient?: { readonly __typename?: 'LandingpageClientType', readonly id: string, readonly sid?: string | undefined, readonly title: string, readonly online: boolean, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly slug: string, readonly brand?: string | undefined, readonly kldb: string, readonly color?: string | undefined, readonly bubbleText?: string | undefined, readonly locationLinksTitle: string, readonly buzzwords?: string | undefined, readonly withJobProposals: boolean, readonly jobPostingId?: string | undefined, readonly utmCampaignId?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly clientlandingpagelogoSet: ReadonlyArray<{ readonly __typename?: 'LogoType', readonly clientLogo?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }>, readonly clientlandingpagelocationsSet: ReadonlyArray<{ readonly __typename?: 'ClientLandingpageLocationsType', readonly title: string, readonly slug: string }>, readonly clientlandingpagelocationsapplicationSet: ReadonlyArray<{ readonly __typename?: 'ClientLandingpageLocationsApplicationType', readonly id: string, readonly name: string, readonly sid?: string | undefined }>, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined, readonly form?: { readonly __typename?: 'FormType', readonly id: string, readonly name: string, readonly formfieldsSet: ReadonlyArray<{ readonly __typename?: 'FormFieldsType', readonly required: boolean, readonly row: number, readonly column: number, readonly field: { readonly __typename?: 'FormFieldType', readonly name: string, readonly defaultValue?: string | undefined, readonly fieldType?: { readonly __typename?: 'FormFieldTypeType', readonly name: string } | undefined } }>, readonly formoptionsSet: ReadonlyArray<{ readonly __typename?: 'FormOptionsType', readonly value: boolean, readonly option: { readonly __typename?: 'FormOptionType', readonly name: string } }> } | undefined } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type LandingPageIndustryQueryVariables = Exact<{
  slug: Scalars['String'];
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  secret?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type LandingPageIndustryQuery = { readonly __typename?: 'Query', readonly landingpageIndustry?: { readonly __typename?: 'LandingpageIndustryType', readonly id: string, readonly title: string, readonly online: boolean, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly buzzwords?: string | undefined, readonly sid?: string | undefined, readonly kldb: string, readonly color?: string | undefined, readonly bubbleText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined, readonly elements?: { readonly __typename?: 'DynamicLandingpageElementsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'DynamicLandingpageElementsEdge', readonly cursor: string, readonly node?: { readonly __typename: 'BenefitsElementType', readonly title: string, readonly order?: number | undefined, readonly buttonText?: string | undefined, readonly buttonLink?: string | undefined, readonly benefitselementitemSet: ReadonlyArray<{ readonly __typename?: 'BenefitsElementItemType', readonly title: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'CtaElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly subline?: string | undefined, readonly linkUrl?: string | undefined, readonly buttonText?: string | undefined } | { readonly __typename: 'FAQElementType', readonly order?: number | undefined, readonly title: string, readonly faqelementitemSet: ReadonlyArray<{ readonly __typename?: 'FAQElementItemType', readonly title: string, readonly text: string }> } | { readonly __typename: 'FactsElementType', readonly order?: number | undefined, readonly title: string, readonly factselementitemSet: ReadonlyArray<{ readonly __typename?: 'FactsElementItemType', readonly id: string, readonly title: string, readonly description: string, readonly icon?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'JobSearchElementType', readonly title: string, readonly sort: string, readonly order?: number | undefined, readonly jobadsDistance: number, readonly jobsearchelementitemSet: ReadonlyArray<{ readonly __typename?: 'JobSearchElementItemType', readonly jobadsGroupId: string }> } | { readonly __typename: 'LinkListElementType', readonly order?: number | undefined, readonly optionalTitle?: string | undefined, readonly linklistelementitemSet: ReadonlyArray<{ readonly __typename?: 'LinkListElementItemType', readonly id: string, readonly linkTitle: string, readonly linkUrl: string, readonly target?: string | undefined }> } | { readonly __typename: 'ListElementType', readonly order?: number | undefined, readonly listelementitemSet: ReadonlyArray<{ readonly __typename?: 'ListElementItemType', readonly id: string, readonly itemText: string }> } | { readonly __typename: 'LocationElementType', readonly order?: number | undefined, readonly title: string, readonly locationelementitemSet: ReadonlyArray<{ readonly __typename?: 'LocationElementItemType', readonly title: string, readonly slug: string, readonly text: string }> } | { readonly __typename: 'MediaElementType', readonly sort: string, readonly order?: number | undefined, readonly title: string, readonly aboveLine?: string | undefined, readonly mediaText: string, readonly mediaType: string, readonly mediaPosition: string, readonly mediaSrc?: string | undefined, readonly mediaFile?: string | undefined, readonly buttonLink?: string | undefined, readonly buttonText?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | { readonly __typename: 'MoreInfoElementType', readonly order?: number | undefined, readonly title: string, readonly optionalText?: string | undefined, readonly moreinfoelementitemSet: ReadonlyArray<{ readonly __typename?: 'MoreInfoElementItemType', readonly title: string, readonly image?: string | undefined, readonly description: string, readonly link: string, readonly buttonText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'ProcessElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly withNumbers: boolean, readonly processelementitemSet: ReadonlyArray<{ readonly __typename?: 'ProcessElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'RequirementsElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly requirementselementitemSet: ReadonlyArray<{ readonly __typename?: 'RequirementsElementItemType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | { readonly __typename: 'SalaryElementType', readonly order?: number | undefined, readonly min: number, readonly max: number, readonly description: string, readonly subline?: string | undefined, readonly title: string } | { readonly __typename: 'SeparatorElementType', readonly order?: number | undefined } | { readonly __typename: 'TabsElementType', readonly order?: number | undefined, readonly id: string, readonly title: string, readonly tabsSubline: string, readonly tabselementitemSet: ReadonlyArray<{ readonly __typename?: 'TabsElementItemType', readonly id: string, readonly title: string, readonly content: string, readonly linkUrl?: string | undefined }> } | { readonly __typename: 'TextElementType', readonly title: string, readonly order?: number | undefined, readonly subline?: string | undefined, readonly text: string } | undefined } | undefined> } | undefined, readonly industrylandingpagelogoSet: ReadonlyArray<{ readonly __typename?: 'IndustryLogoType', readonly industryLogo?: string | undefined, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined }> } | undefined, readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type LinkFormQueryVariables = Exact<{
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type LinkFormQuery = { readonly __typename?: 'Query', readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type LinkGeneratorQueryVariables = Exact<{
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type LinkGeneratorQuery = { readonly __typename?: 'Query', readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined };

export type ProActivePageQueryVariables = Exact<{
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  formName: Scalars['String'];
  countryCode: Scalars['String'];
  tenantId: Scalars['Int'];
}>;


export type ProActivePageQuery = { readonly __typename?: 'Query', readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined, readonly form?: { readonly __typename?: 'FormType', readonly id: string, readonly name: string, readonly formfieldsSet: ReadonlyArray<{ readonly __typename?: 'FormFieldsType', readonly required: boolean, readonly row: number, readonly column: number, readonly field: { readonly __typename?: 'FormFieldType', readonly name: string, readonly defaultValue?: string | undefined, readonly fieldType?: { readonly __typename?: 'FormFieldTypeType', readonly name: string } | undefined } }>, readonly formoptionsSet: ReadonlyArray<{ readonly __typename?: 'FormOptionsType', readonly value: boolean, readonly option: { readonly __typename?: 'FormOptionType', readonly name: string } }> } | undefined, readonly branchesForProActiveApplications?: ReadonlyArray<{ readonly __typename?: 'BranchType', readonly sid: string, readonly gebiet?: string | undefined, readonly ort?: string | undefined, readonly plz?: string | undefined, readonly strasse?: string | undefined, readonly standort?: string | undefined, readonly standortExtern?: string | undefined } | undefined> | undefined };

export type ThankyouTeasersQueryVariables = Exact<{
  languages: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
}>;


export type ThankyouTeasersQuery = { readonly __typename?: 'Query', readonly frontendTranslations?: ReadonlyArray<{ readonly __typename?: 'LanguageTranslationType', readonly language?: string | undefined, readonly translations?: ReadonlyArray<{ readonly __typename?: 'TranslationType', readonly key?: string | undefined, readonly value?: string | undefined } | undefined> | undefined } | undefined> | undefined, readonly frontendConfigurations?: ReadonlyArray<{ readonly __typename?: 'ConfigurationType', readonly key: string, readonly value: string } | undefined> | undefined, readonly recoTeasers?: ReadonlyArray<{ readonly __typename?: 'RecoTeaserType', readonly title: string, readonly subline: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined, readonly thankyouTeasers?: ReadonlyArray<{ readonly __typename?: 'ThankYouTeaserType', readonly title: string, readonly description: string, readonly image?: string | undefined, readonly link: string, readonly linkText: string, readonly cloudinaryImage?: { readonly __typename?: 'CloudinaryImageType', readonly image: string, readonly alt?: string | undefined } | undefined } | undefined> | undefined };

export const JobBaseInfoFragmentDoc = gql`
    fragment JobBaseInfo on JobAdType {
  title
  onlineDate
  employmentType
  placementType
  workHours
  jobLocation
  officeId
  sourceJobId
  industry
  occupation
  occupationMainGroup
  jobLocation
  kldbNumber
  cvMandatory
  branchId
}
    `;
export const ElementsFragmentFragmentDoc = gql`
    fragment ElementsFragment on DynamicLandingpageElementsConnection {
  edges {
    cursor
    node {
      ... on BenefitsElementType {
        __typename
        title
        order
        buttonText
        buttonLink
        benefitselementitemSet {
          title
          image
          cloudinaryImage {
            image
            alt
          }
        }
      }
      ... on ProcessElementType {
        __typename
        title
        order
        subline
        processelementitemSet {
          title
          description
          image
          cloudinaryImage {
            image
            alt
          }
        }
        withNumbers
      }
      ... on RequirementsElementType {
        __typename
        title
        order
        subline
        requirementselementitemSet {
          title
          description
          image
          cloudinaryImage {
            image
            alt
          }
        }
      }
      ... on TextElementType {
        __typename
        title
        order
        subline
        text
      }
      ... on FAQElementType {
        __typename
        order
        title
        faqelementitemSet {
          title
          text
        }
      }
      ... on LocationElementType {
        __typename
        order
        title
        locationelementitemSet {
          title
          slug
          text
        }
      }
      ... on MediaElementType {
        __typename
        sort
        order
        title
        aboveLine
        mediaText
        mediaType
        mediaPosition
        mediaSrc
        mediaFile
        buttonLink
        buttonText
        cloudinaryImage {
          image
          alt
        }
      }
      ... on MoreInfoElementType {
        __typename
        order
        title
        optionalText
        moreinfoelementitemSet {
          title
          image
          description
          link
          buttonText
          cloudinaryImage {
            image
            alt
          }
        }
      }
      ... on SeparatorElementType {
        __typename
        order
      }
      ... on SalaryElementType {
        __typename
        order
        min
        max
        description
        subline
        title
      }
      ... on JobSearchElementType {
        __typename
        title
        sort
        order
        jobadsDistance
        jobsearchelementitemSet {
          jobadsGroupId
        }
      }
      ... on FactsElementType {
        __typename
        order
        title
        factselementitemSet {
          id
          title
          description
          icon
          cloudinaryImage {
            image
            alt
          }
        }
      }
      ... on ListElementType {
        __typename
        order
        listelementitemSet {
          id
          itemText
        }
      }
      ... on LinkListElementType {
        __typename
        order
        optionalTitle
        linklistelementitemSet {
          id
          linkTitle
          linkUrl
          target
        }
      }
      ... on TabsElementType {
        __typename
        order
        id
        title
        tabsSubline
        tabselementitemSet {
          id
          title
          content
          linkUrl
        }
      }
      ... on CtaElementType {
        __typename
        order
        id
        title
        subline
        linkUrl
        buttonText
      }
    }
  }
}
    `;
export const FormFragmentFragmentDoc = gql`
    fragment FormFragment on FormType {
  id
  name
  formfieldsSet {
    field {
      name
      fieldType {
        name
      }
      defaultValue
    }
    required
    row
    column
  }
  formoptionsSet {
    option {
      name
    }
    value
  }
}
    `;
export const LandingBrandedFragmentFragmentDoc = gql`
    fragment LandingBrandedFragment on LandingpageBrandedType {
  id
  title
  sid
  online
  subline
  description
  image
  cloudinaryImage {
    image
    alt
  }
  slug
  brand
  kldb
  color
  bubbleText
  buzzwords
  elements {
    ...ElementsFragment
  }
  form {
    ...FormFragment
  }
  brandedlandingpagelogoSet {
    brandedLogo
    cloudinaryImage {
      image
      alt
    }
  }
  brandedlandingpagelocationsSet {
    title
    slug
  }
  brandedlandingpagelocationsapplicationSet {
    id
    name
    sid
  }
  jobPostingId
  utmCampaignId
}
    ${ElementsFragmentFragmentDoc}
${FormFragmentFragmentDoc}`;
export const LandingPageClientFragmentFragmentDoc = gql`
    fragment LandingPageClientFragment on LandingpageClientType {
  id
  sid
  title
  online
  subline
  description
  image
  cloudinaryImage {
    image
    alt
  }
  slug
  brand
  kldb
  color
  bubbleText
  locationLinksTitle
  buzzwords
  clientlandingpagelogoSet {
    clientLogo
    cloudinaryImage {
      image
      alt
    }
  }
  clientlandingpagelocationsSet {
    title
    slug
  }
  clientlandingpagelocationsapplicationSet {
    id
    name
    sid
  }
  elements {
    ...ElementsFragment
  }
  form {
    ...FormFragment
  }
  withJobProposals
  jobPostingId
  utmCampaignId
}
    ${ElementsFragmentFragmentDoc}
${FormFragmentFragmentDoc}`;
export const LandingPageIndustryFragmentFragmentDoc = gql`
    fragment LandingPageIndustryFragment on LandingpageIndustryType {
  id
  title
  online
  subline
  description
  image
  buzzwords
  cloudinaryImage {
    image
    alt
  }
  sid
  kldb
  elements {
    ...ElementsFragment
  }
  color
  bubbleText
  industrylandingpagelogoSet {
    industryLogo
    cloudinaryImage {
      image
      alt
    }
  }
}
    ${ElementsFragmentFragmentDoc}`;
export const LandingPageKldbFragmentFragmentDoc = gql`
    fragment LandingPageKLDBFragment on LandingpageKLDBType {
  id
  title
  online
  subline
  description
  image
  buzzwords
  cloudinaryImage {
    image
    alt
  }
  sid
  kldb
  formType
  form {
    ...FormFragment
  }
  kldblandingpagelocationsapplicationSet {
    id
    name
    sid
  }
  elements {
    ...ElementsFragment
  }
  withJobProposals
  jobPostingId
}
    ${FormFragmentFragmentDoc}
${ElementsFragmentFragmentDoc}`;
export const RecoTeaserFragmentFragmentDoc = gql`
    fragment RecoTeaserFragment on RecoTeaserType {
  title
  subline
  description
  image
  link
  linkText
  cloudinaryImage {
    image
    alt
  }
}
    `;
export const ThankYouTeaserFragmentFragmentDoc = gql`
    fragment ThankYouTeaserFragment on ThankYouTeaserType {
  title
  description
  image
  link
  linkText
  cloudinaryImage {
    image
    alt
  }
}
    `;
export const CreateAppDocument = gql`
    mutation CreateApp($fileCv: Upload, $fileOthers: Upload, $firstName: String!, $lastName: String!, $street: String!, $number: String!, $zipcode: String!, $city: String!, $phone: String!, $phoneCountryCode: String!, $email: String!, $jobId: String, $greeting: String, $desiredPosition: String, $desiredJobLocation: String, $transactionId: String, $varSource: String, $varCampaign: String, $varContent: String, $varMedium: String, $sid: String, $varType: String!, $varTerm: String, $countryCode: String!, $schaltungsId: String, $above18: Boolean, $branchId: String, $isSpontaneous: Boolean, $marketingPreferencesStatus: Boolean, $marketingPreferencesType: String, $privacyConsentStatus: Boolean, $privacyConsentType: String, $privacyConsentVersion: String, $termsAndConditionsStatus: Boolean, $maxCommuteDistanceKm: Int, $numberMonthsUpdateCheck: Int) {
  createApplication(
    input: {fileCv: $fileCv, fileOthers: $fileOthers, firstName: $firstName, lastName: $lastName, street: $street, number: $number, zipcode: $zipcode, city: $city, phone: $phone, phoneCountryCode: $phoneCountryCode, email: $email, jobId: $jobId, greeting: $greeting, desiredPosition: $desiredPosition, desiredJobLocation: $desiredJobLocation, transactionId: $transactionId, varSource: $varSource, varCampaign: $varCampaign, varContent: $varContent, varMedium: $varMedium, sid: $sid, varType: $varType, varTerm: $varTerm, countryCode: $countryCode, schaltungsId: $schaltungsId, above18: $above18, branchId: $branchId, isSpontaneous: $isSpontaneous, marketingPreferencesStatus: $marketingPreferencesStatus, marketingPreferencesType: $marketingPreferencesType, privacyConsentStatus: $privacyConsentStatus, privacyConsentType: $privacyConsentType, privacyConsentVersion: $privacyConsentVersion, termsAndConditionsStatus: $termsAndConditionsStatus, maxCommuteDistanceKm: $maxCommuteDistanceKm, numberMonthsUpdateCheck: $numberMonthsUpdateCheck}
  ) {
    errors {
      field
      messages
    }
  }
}
    `;

/**
 * __useCreateAppMutation__
 *
 * To run a mutation, you first call `useCreateAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppMutation, { data, loading, error }] = useCreateAppMutation({
 *   variables: {
 *      fileCv: // value for 'fileCv'
 *      fileOthers: // value for 'fileOthers'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      street: // value for 'street'
 *      number: // value for 'number'
 *      zipcode: // value for 'zipcode'
 *      city: // value for 'city'
 *      phone: // value for 'phone'
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *      email: // value for 'email'
 *      jobId: // value for 'jobId'
 *      greeting: // value for 'greeting'
 *      desiredPosition: // value for 'desiredPosition'
 *      desiredJobLocation: // value for 'desiredJobLocation'
 *      transactionId: // value for 'transactionId'
 *      varSource: // value for 'varSource'
 *      varCampaign: // value for 'varCampaign'
 *      varContent: // value for 'varContent'
 *      varMedium: // value for 'varMedium'
 *      sid: // value for 'sid'
 *      varType: // value for 'varType'
 *      varTerm: // value for 'varTerm'
 *      countryCode: // value for 'countryCode'
 *      schaltungsId: // value for 'schaltungsId'
 *      above18: // value for 'above18'
 *      branchId: // value for 'branchId'
 *      isSpontaneous: // value for 'isSpontaneous'
 *      marketingPreferencesStatus: // value for 'marketingPreferencesStatus'
 *      marketingPreferencesType: // value for 'marketingPreferencesType'
 *      privacyConsentStatus: // value for 'privacyConsentStatus'
 *      privacyConsentType: // value for 'privacyConsentType'
 *      privacyConsentVersion: // value for 'privacyConsentVersion'
 *      termsAndConditionsStatus: // value for 'termsAndConditionsStatus'
 *      maxCommuteDistanceKm: // value for 'maxCommuteDistanceKm'
 *      numberMonthsUpdateCheck: // value for 'numberMonthsUpdateCheck'
 *   },
 * });
 */
export function useCreateAppMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAppMutation, CreateAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAppMutation, CreateAppMutationVariables>(CreateAppDocument, options);
      }
export type CreateAppMutationHookResult = ReturnType<typeof useCreateAppMutation>;
export type CreateAppMutationResult = ApolloReactCommon.MutationResult<CreateAppMutation>;
export type CreateAppMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAppMutation, CreateAppMutationVariables>;
export const ErrorPageDocument = gql`
    query ErrorPage($languages: [String]!, $countryCode: String!) {
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    `;

/**
 * __useErrorPageQuery__
 *
 * To run a query within a React component, call `useErrorPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrorPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrorPageQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useErrorPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ErrorPageQuery, ErrorPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ErrorPageQuery, ErrorPageQueryVariables>(ErrorPageDocument, options);
      }
export function useErrorPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ErrorPageQuery, ErrorPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ErrorPageQuery, ErrorPageQueryVariables>(ErrorPageDocument, options);
        }
export type ErrorPageQueryHookResult = ReturnType<typeof useErrorPageQuery>;
export type ErrorPageLazyQueryHookResult = ReturnType<typeof useErrorPageLazyQuery>;
export type ErrorPageQueryResult = ApolloReactCommon.QueryResult<ErrorPageQuery, ErrorPageQueryVariables>;
export const JobLinkDocument = gql`
    query JobLink($sourceAdId: String!, $languages: [String]!, $countryCode: String!) {
  jobad(sourceAdId: $sourceAdId, countryCode: $countryCode) {
    occupation
    jobLocation
    kldbNumber
    sourceAdId
    sourceJobId
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    `;

/**
 * __useJobLinkQuery__
 *
 * To run a query within a React component, call `useJobLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobLinkQuery({
 *   variables: {
 *      sourceAdId: // value for 'sourceAdId'
 *      languages: // value for 'languages'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useJobLinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JobLinkQuery, JobLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JobLinkQuery, JobLinkQueryVariables>(JobLinkDocument, options);
      }
export function useJobLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobLinkQuery, JobLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JobLinkQuery, JobLinkQueryVariables>(JobLinkDocument, options);
        }
export type JobLinkQueryHookResult = ReturnType<typeof useJobLinkQuery>;
export type JobLinkLazyQueryHookResult = ReturnType<typeof useJobLinkLazyQuery>;
export type JobLinkQueryResult = ApolloReactCommon.QueryResult<JobLinkQuery, JobLinkQueryVariables>;
export const JobDetailsDocument = gql`
    query JobDetails($sourceAdId: String!, $languages: [String]!, $countryCode: String!) {
  jobad(sourceAdId: $sourceAdId, countryCode: $countryCode) {
    ats
    baseSalaryCurrency
    baseSalaryMax
    baseSalaryMin
    baseSalaryPubExternally
    baseSalaryUnit
    benefits
    benefitsTitle
    clientLogoImage
    closingText
    closingTextTitle
    contactCity
    contactMail
    contactName
    contactPhone
    contactStreet
    contactZip
    cvMandatory
    education
    employmentType
    industry
    introText
    jobLocation
    jobadlocationSet {
      isMainLocation
      location
    }
    jobRegion
    jobZipCode
    kldbNumber
    medationType
    occupation
    occupationalType
    occupationGroup
    occupationMainGroup
    offlineDate
    onlineDate
    placementType
    qualifications
    qualificationsTitle
    responsibilities
    responsibilitiesTitle
    schaltungsId
    sourceAdId
    sourceJobId
    title
    workHours
    group {
      ogDescription
      ogImage
      aboutUs
      elements {
        ...ElementsFragment
      }
    }
    workExperiences
    remoteOption
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    ${ElementsFragmentFragmentDoc}`;

/**
 * __useJobDetailsQuery__
 *
 * To run a query within a React component, call `useJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDetailsQuery({
 *   variables: {
 *      sourceAdId: // value for 'sourceAdId'
 *      languages: // value for 'languages'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useJobDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JobDetailsQuery, JobDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, options);
      }
export function useJobDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobDetailsQuery, JobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, options);
        }
export type JobDetailsQueryHookResult = ReturnType<typeof useJobDetailsQuery>;
export type JobDetailsLazyQueryHookResult = ReturnType<typeof useJobDetailsLazyQuery>;
export type JobDetailsQueryResult = ApolloReactCommon.QueryResult<JobDetailsQuery, JobDetailsQueryVariables>;
export const JobApplyDocument = gql`
    query JobApply($sourceAdId: String!, $languages: [String]!, $countryCode: String!) {
  jobad(sourceAdId: $sourceAdId, countryCode: $countryCode) {
    title
    onlineDate
    employmentType
    placementType
    workHours
    jobLocation
    officeId
    sourceJobId
    sourceAdId
    industry
    occupation
    occupationMainGroup
    kldbNumber
    cvMandatory
    branchId
    baseSalaryCurrency
    baseSalaryMax
    baseSalaryMin
    baseSalaryUnit
    benefits
    clientLogoImage
    closingText
    contactCity
    contactMail
    contactName
    contactPhone
    contactSex
    contactStreet
    contactZip
    education
    introText
    jobRegion
    jobZipCode
    jobadlocationSet {
      isMainLocation
      location
    }
    medationType
    occupationGroup
    offlineDate
    qualifications
    responsibilities
    schaltungsId
    group {
      ogDescription
      ogImage
      aboutUs
      elements {
        edges {
          node {
            ... on BenefitsElementType {
              __typename
              title
              order
              buttonText
              buttonLink
              benefitselementitemSet {
                title
                image
                cloudinaryImage {
                  image
                  alt
                }
              }
            }
          }
        }
      }
    }
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    `;

/**
 * __useJobApplyQuery__
 *
 * To run a query within a React component, call `useJobApplyQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobApplyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobApplyQuery({
 *   variables: {
 *      sourceAdId: // value for 'sourceAdId'
 *      languages: // value for 'languages'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useJobApplyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JobApplyQuery, JobApplyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JobApplyQuery, JobApplyQueryVariables>(JobApplyDocument, options);
      }
export function useJobApplyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobApplyQuery, JobApplyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JobApplyQuery, JobApplyQueryVariables>(JobApplyDocument, options);
        }
export type JobApplyQueryHookResult = ReturnType<typeof useJobApplyQuery>;
export type JobApplyLazyQueryHookResult = ReturnType<typeof useJobApplyLazyQuery>;
export type JobApplyQueryResult = ApolloReactCommon.QueryResult<JobApplyQuery, JobApplyQueryVariables>;
export const JobDetailsWithTeasersDocument = gql`
    query JobDetailsWithTeasers($sourceAdId: String!, $languages: [String]!, $countryCode: String!) {
  jobad(sourceAdId: $sourceAdId, countryCode: $countryCode) {
    employmentType
    jobLocation
    jobZipCode
    kldbNumber
    occupation
    occupationalType
    occupationGroup
    occupationMainGroup
    placementType
    schaltungsId
    sourceAdId
    sourceJobId
    title
    workHours
  }
  recoTeasers(countryCode: $countryCode) {
    ...RecoTeaserFragment
  }
  thankyouTeasers(countryCode: $countryCode) {
    ...ThankYouTeaserFragment
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    ${RecoTeaserFragmentFragmentDoc}
${ThankYouTeaserFragmentFragmentDoc}`;

/**
 * __useJobDetailsWithTeasersQuery__
 *
 * To run a query within a React component, call `useJobDetailsWithTeasersQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDetailsWithTeasersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDetailsWithTeasersQuery({
 *   variables: {
 *      sourceAdId: // value for 'sourceAdId'
 *      languages: // value for 'languages'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useJobDetailsWithTeasersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JobDetailsWithTeasersQuery, JobDetailsWithTeasersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JobDetailsWithTeasersQuery, JobDetailsWithTeasersQueryVariables>(JobDetailsWithTeasersDocument, options);
      }
export function useJobDetailsWithTeasersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobDetailsWithTeasersQuery, JobDetailsWithTeasersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JobDetailsWithTeasersQuery, JobDetailsWithTeasersQueryVariables>(JobDetailsWithTeasersDocument, options);
        }
export type JobDetailsWithTeasersQueryHookResult = ReturnType<typeof useJobDetailsWithTeasersQuery>;
export type JobDetailsWithTeasersLazyQueryHookResult = ReturnType<typeof useJobDetailsWithTeasersLazyQuery>;
export type JobDetailsWithTeasersQueryResult = ApolloReactCommon.QueryResult<JobDetailsWithTeasersQuery, JobDetailsWithTeasersQueryVariables>;
export const JobListDocument = gql`
    query JobList($kldbNumber: String!, $countryCode: String!) {
  jobads(kldbNumber: $kldbNumber, countryCode: $countryCode) {
    title
    onlineDate
    employmentType
    placementType
    workHours
    jobLocation
    officeId
    sourceJobId
    sourceJobId
    industry
    careerStage
    occupation
    jobLocation
    kldbNumber
    cvMandatory
    sourceAdId
    schaltungsId
  }
}
    `;

/**
 * __useJobListQuery__
 *
 * To run a query within a React component, call `useJobListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobListQuery({
 *   variables: {
 *      kldbNumber: // value for 'kldbNumber'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useJobListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JobListQuery, JobListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JobListQuery, JobListQueryVariables>(JobListDocument, options);
      }
export function useJobListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobListQuery, JobListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JobListQuery, JobListQueryVariables>(JobListDocument, options);
        }
export type JobListQueryHookResult = ReturnType<typeof useJobListQuery>;
export type JobListLazyQueryHookResult = ReturnType<typeof useJobListLazyQuery>;
export type JobListQueryResult = ApolloReactCommon.QueryResult<JobListQuery, JobListQueryVariables>;
export const JobGroupDocument = gql`
    query JobGroup($kldbNumber: String!, $languages: [String]!, $countryCode: String!) {
  jobgroup(kldbNumber: $kldbNumber, countryCode: $countryCode) {
    id
    kldbNumber
    title
    count
    jobads {
      id
      title
      onlineDate
      employmentType
      placementType
      workHours
      jobLocation
      officeId
      sourceJobId
      industry
      careerStage
      occupation
      jobLocation
      kldbNumber
      cvMandatory
      sourceAdId
    }
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    `;

/**
 * __useJobGroupQuery__
 *
 * To run a query within a React component, call `useJobGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobGroupQuery({
 *   variables: {
 *      kldbNumber: // value for 'kldbNumber'
 *      languages: // value for 'languages'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useJobGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JobGroupQuery, JobGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JobGroupQuery, JobGroupQueryVariables>(JobGroupDocument, options);
      }
export function useJobGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobGroupQuery, JobGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JobGroupQuery, JobGroupQueryVariables>(JobGroupDocument, options);
        }
export type JobGroupQueryHookResult = ReturnType<typeof useJobGroupQuery>;
export type JobGroupLazyQueryHookResult = ReturnType<typeof useJobGroupLazyQuery>;
export type JobGroupQueryResult = ApolloReactCommon.QueryResult<JobGroupQuery, JobGroupQueryVariables>;
export const JobsByDistanceDocument = gql`
    query JobsByDistance($plz: String!, $kldbNumbers: [String!]!, $limit: Int, $distance: Int, $countryCode: String!) {
  jobadsByDistance(
    plz: $plz
    kldbNumbers: $kldbNumbers
    limit: $limit
    distance: $distance
    countryCode: $countryCode
  ) {
    id
    title
    employmentType
    jobLocation
    onlineDate
    sourceAdId
    sourceJobId
    workHours
    schaltungsId
  }
}
    `;

/**
 * __useJobsByDistanceQuery__
 *
 * To run a query within a React component, call `useJobsByDistanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsByDistanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsByDistanceQuery({
 *   variables: {
 *      plz: // value for 'plz'
 *      kldbNumbers: // value for 'kldbNumbers'
 *      limit: // value for 'limit'
 *      distance: // value for 'distance'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useJobsByDistanceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JobsByDistanceQuery, JobsByDistanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JobsByDistanceQuery, JobsByDistanceQueryVariables>(JobsByDistanceDocument, options);
      }
export function useJobsByDistanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobsByDistanceQuery, JobsByDistanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JobsByDistanceQuery, JobsByDistanceQueryVariables>(JobsByDistanceDocument, options);
        }
export type JobsByDistanceQueryHookResult = ReturnType<typeof useJobsByDistanceQuery>;
export type JobsByDistanceLazyQueryHookResult = ReturnType<typeof useJobsByDistanceLazyQuery>;
export type JobsByDistanceQueryResult = ApolloReactCommon.QueryResult<JobsByDistanceQuery, JobsByDistanceQueryVariables>;
export const LandingpageBrandedSentDocument = gql`
    query LandingpageBrandedSent($slug: String!, $languages: [String]!, $secret: String, $countryCode: String!) {
  landingpageBranded(slug: $slug, secret: $secret, countryCode: $countryCode) {
    kldb
    title
    brand
    image
    cloudinaryImage {
      image
      alt
    }
    brandedlandingpagelogoSet {
      brandedLogo
      cloudinaryImage {
        image
        alt
      }
    }
    online
    id
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
  recoTeasers(countryCode: $countryCode) {
    ...RecoTeaserFragment
  }
  thankyouTeasers(countryCode: $countryCode) {
    ...ThankYouTeaserFragment
  }
}
    ${RecoTeaserFragmentFragmentDoc}
${ThankYouTeaserFragmentFragmentDoc}`;

/**
 * __useLandingpageBrandedSentQuery__
 *
 * To run a query within a React component, call `useLandingpageBrandedSentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingpageBrandedSentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingpageBrandedSentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      languages: // value for 'languages'
 *      secret: // value for 'secret'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useLandingpageBrandedSentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LandingpageBrandedSentQuery, LandingpageBrandedSentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LandingpageBrandedSentQuery, LandingpageBrandedSentQueryVariables>(LandingpageBrandedSentDocument, options);
      }
export function useLandingpageBrandedSentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LandingpageBrandedSentQuery, LandingpageBrandedSentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LandingpageBrandedSentQuery, LandingpageBrandedSentQueryVariables>(LandingpageBrandedSentDocument, options);
        }
export type LandingpageBrandedSentQueryHookResult = ReturnType<typeof useLandingpageBrandedSentQuery>;
export type LandingpageBrandedSentLazyQueryHookResult = ReturnType<typeof useLandingpageBrandedSentLazyQuery>;
export type LandingpageBrandedSentQueryResult = ApolloReactCommon.QueryResult<LandingpageBrandedSentQuery, LandingpageBrandedSentQueryVariables>;
export const LandingpageClientSentDocument = gql`
    query LandingpageClientSent($slug: String!, $languages: [String]!, $secret: String, $countryCode: String!) {
  landingpageClient(slug: $slug, secret: $secret, countryCode: $countryCode) {
    kldb
    title
    brand
    withJobProposals
    online
    clientlandingpagelocationsapplicationSet {
      name
    }
    id
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
  recoTeasers(countryCode: $countryCode) {
    ...RecoTeaserFragment
  }
  thankyouTeasers(countryCode: $countryCode) {
    ...ThankYouTeaserFragment
  }
}
    ${RecoTeaserFragmentFragmentDoc}
${ThankYouTeaserFragmentFragmentDoc}`;

/**
 * __useLandingpageClientSentQuery__
 *
 * To run a query within a React component, call `useLandingpageClientSentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingpageClientSentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingpageClientSentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      languages: // value for 'languages'
 *      secret: // value for 'secret'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useLandingpageClientSentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LandingpageClientSentQuery, LandingpageClientSentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LandingpageClientSentQuery, LandingpageClientSentQueryVariables>(LandingpageClientSentDocument, options);
      }
export function useLandingpageClientSentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LandingpageClientSentQuery, LandingpageClientSentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LandingpageClientSentQuery, LandingpageClientSentQueryVariables>(LandingpageClientSentDocument, options);
        }
export type LandingpageClientSentQueryHookResult = ReturnType<typeof useLandingpageClientSentQuery>;
export type LandingpageClientSentLazyQueryHookResult = ReturnType<typeof useLandingpageClientSentLazyQuery>;
export type LandingpageClientSentQueryResult = ApolloReactCommon.QueryResult<LandingpageClientSentQuery, LandingpageClientSentQueryVariables>;
export const LandingPageKldbDocument = gql`
    query LandingPageKLDB($slug: String!, $languages: [String]!, $secret: String, $countryCode: String!) {
  landingpageKldb(slug: $slug, secret: $secret, countryCode: $countryCode) {
    ...LandingPageKLDBFragment
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    ${LandingPageKldbFragmentFragmentDoc}`;

/**
 * __useLandingPageKldbQuery__
 *
 * To run a query within a React component, call `useLandingPageKldbQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageKldbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageKldbQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      languages: // value for 'languages'
 *      secret: // value for 'secret'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useLandingPageKldbQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LandingPageKldbQuery, LandingPageKldbQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LandingPageKldbQuery, LandingPageKldbQueryVariables>(LandingPageKldbDocument, options);
      }
export function useLandingPageKldbLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LandingPageKldbQuery, LandingPageKldbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LandingPageKldbQuery, LandingPageKldbQueryVariables>(LandingPageKldbDocument, options);
        }
export type LandingPageKldbQueryHookResult = ReturnType<typeof useLandingPageKldbQuery>;
export type LandingPageKldbLazyQueryHookResult = ReturnType<typeof useLandingPageKldbLazyQuery>;
export type LandingPageKldbQueryResult = ApolloReactCommon.QueryResult<LandingPageKldbQuery, LandingPageKldbQueryVariables>;
export const LandingPageKldbConfirmDocument = gql`
    query LandingPageKLDBConfirm($slug: String!, $languages: [String]!, $secret: String, $countryCode: String!) {
  landingpageKldb(slug: $slug, secret: $secret, countryCode: $countryCode) {
    ...LandingPageKLDBFragment
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
  recoTeasers(countryCode: $countryCode) {
    ...RecoTeaserFragment
  }
  thankyouTeasers(countryCode: $countryCode) {
    ...ThankYouTeaserFragment
  }
}
    ${LandingPageKldbFragmentFragmentDoc}
${RecoTeaserFragmentFragmentDoc}
${ThankYouTeaserFragmentFragmentDoc}`;

/**
 * __useLandingPageKldbConfirmQuery__
 *
 * To run a query within a React component, call `useLandingPageKldbConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageKldbConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageKldbConfirmQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      languages: // value for 'languages'
 *      secret: // value for 'secret'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useLandingPageKldbConfirmQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LandingPageKldbConfirmQuery, LandingPageKldbConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LandingPageKldbConfirmQuery, LandingPageKldbConfirmQueryVariables>(LandingPageKldbConfirmDocument, options);
      }
export function useLandingPageKldbConfirmLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LandingPageKldbConfirmQuery, LandingPageKldbConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LandingPageKldbConfirmQuery, LandingPageKldbConfirmQueryVariables>(LandingPageKldbConfirmDocument, options);
        }
export type LandingPageKldbConfirmQueryHookResult = ReturnType<typeof useLandingPageKldbConfirmQuery>;
export type LandingPageKldbConfirmLazyQueryHookResult = ReturnType<typeof useLandingPageKldbConfirmLazyQuery>;
export type LandingPageKldbConfirmQueryResult = ApolloReactCommon.QueryResult<LandingPageKldbConfirmQuery, LandingPageKldbConfirmQueryVariables>;
export const LandingPageKldbSentDocument = gql`
    query LandingPageKLDBSent($slug: String!, $languages: [String]!, $secret: String, $countryCode: String!) {
  landingpageKldb(slug: $slug, secret: $secret, countryCode: $countryCode) {
    kldb
    formType
    title
    withJobProposals
    online
    id
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
  recoTeasers(countryCode: $countryCode) {
    ...RecoTeaserFragment
  }
  thankyouTeasers(countryCode: $countryCode) {
    ...ThankYouTeaserFragment
  }
}
    ${RecoTeaserFragmentFragmentDoc}
${ThankYouTeaserFragmentFragmentDoc}`;

/**
 * __useLandingPageKldbSentQuery__
 *
 * To run a query within a React component, call `useLandingPageKldbSentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageKldbSentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageKldbSentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      languages: // value for 'languages'
 *      secret: // value for 'secret'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useLandingPageKldbSentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LandingPageKldbSentQuery, LandingPageKldbSentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LandingPageKldbSentQuery, LandingPageKldbSentQueryVariables>(LandingPageKldbSentDocument, options);
      }
export function useLandingPageKldbSentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LandingPageKldbSentQuery, LandingPageKldbSentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LandingPageKldbSentQuery, LandingPageKldbSentQueryVariables>(LandingPageKldbSentDocument, options);
        }
export type LandingPageKldbSentQueryHookResult = ReturnType<typeof useLandingPageKldbSentQuery>;
export type LandingPageKldbSentLazyQueryHookResult = ReturnType<typeof useLandingPageKldbSentLazyQuery>;
export type LandingPageKldbSentQueryResult = ApolloReactCommon.QueryResult<LandingPageKldbSentQuery, LandingPageKldbSentQueryVariables>;
export const BrandedLandingPageDocument = gql`
    query BrandedLandingPage($slug: String!, $languages: [String]!, $secret: String, $countryCode: String!) {
  landingpageBranded(slug: $slug, secret: $secret, countryCode: $countryCode) {
    ...LandingBrandedFragment
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    ${LandingBrandedFragmentFragmentDoc}`;

/**
 * __useBrandedLandingPageQuery__
 *
 * To run a query within a React component, call `useBrandedLandingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandedLandingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandedLandingPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      languages: // value for 'languages'
 *      secret: // value for 'secret'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useBrandedLandingPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BrandedLandingPageQuery, BrandedLandingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandedLandingPageQuery, BrandedLandingPageQueryVariables>(BrandedLandingPageDocument, options);
      }
export function useBrandedLandingPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandedLandingPageQuery, BrandedLandingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandedLandingPageQuery, BrandedLandingPageQueryVariables>(BrandedLandingPageDocument, options);
        }
export type BrandedLandingPageQueryHookResult = ReturnType<typeof useBrandedLandingPageQuery>;
export type BrandedLandingPageLazyQueryHookResult = ReturnType<typeof useBrandedLandingPageLazyQuery>;
export type BrandedLandingPageQueryResult = ApolloReactCommon.QueryResult<BrandedLandingPageQuery, BrandedLandingPageQueryVariables>;
export const ClientLandingPageDocument = gql`
    query ClientLandingPage($slug: String!, $languages: [String]!, $secret: String, $countryCode: String!) {
  landingpageClient(slug: $slug, secret: $secret, countryCode: $countryCode) {
    ...LandingPageClientFragment
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    ${LandingPageClientFragmentFragmentDoc}`;

/**
 * __useClientLandingPageQuery__
 *
 * To run a query within a React component, call `useClientLandingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientLandingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientLandingPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      languages: // value for 'languages'
 *      secret: // value for 'secret'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useClientLandingPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClientLandingPageQuery, ClientLandingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientLandingPageQuery, ClientLandingPageQueryVariables>(ClientLandingPageDocument, options);
      }
export function useClientLandingPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientLandingPageQuery, ClientLandingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientLandingPageQuery, ClientLandingPageQueryVariables>(ClientLandingPageDocument, options);
        }
export type ClientLandingPageQueryHookResult = ReturnType<typeof useClientLandingPageQuery>;
export type ClientLandingPageLazyQueryHookResult = ReturnType<typeof useClientLandingPageLazyQuery>;
export type ClientLandingPageQueryResult = ApolloReactCommon.QueryResult<ClientLandingPageQuery, ClientLandingPageQueryVariables>;
export const LandingPageIndustryDocument = gql`
    query LandingPageIndustry($slug: String!, $languages: [String]!, $secret: String, $countryCode: String!) {
  landingpageIndustry(slug: $slug, secret: $secret, countryCode: $countryCode) {
    ...LandingPageIndustryFragment
  }
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    ${LandingPageIndustryFragmentFragmentDoc}`;

/**
 * __useLandingPageIndustryQuery__
 *
 * To run a query within a React component, call `useLandingPageIndustryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageIndustryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageIndustryQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      languages: // value for 'languages'
 *      secret: // value for 'secret'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useLandingPageIndustryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LandingPageIndustryQuery, LandingPageIndustryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LandingPageIndustryQuery, LandingPageIndustryQueryVariables>(LandingPageIndustryDocument, options);
      }
export function useLandingPageIndustryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LandingPageIndustryQuery, LandingPageIndustryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LandingPageIndustryQuery, LandingPageIndustryQueryVariables>(LandingPageIndustryDocument, options);
        }
export type LandingPageIndustryQueryHookResult = ReturnType<typeof useLandingPageIndustryQuery>;
export type LandingPageIndustryLazyQueryHookResult = ReturnType<typeof useLandingPageIndustryLazyQuery>;
export type LandingPageIndustryQueryResult = ApolloReactCommon.QueryResult<LandingPageIndustryQuery, LandingPageIndustryQueryVariables>;
export const LinkFormDocument = gql`
    query LinkForm($languages: [String]!, $countryCode: String!) {
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    `;

/**
 * __useLinkFormQuery__
 *
 * To run a query within a React component, call `useLinkFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkFormQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useLinkFormQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LinkFormQuery, LinkFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LinkFormQuery, LinkFormQueryVariables>(LinkFormDocument, options);
      }
export function useLinkFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LinkFormQuery, LinkFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LinkFormQuery, LinkFormQueryVariables>(LinkFormDocument, options);
        }
export type LinkFormQueryHookResult = ReturnType<typeof useLinkFormQuery>;
export type LinkFormLazyQueryHookResult = ReturnType<typeof useLinkFormLazyQuery>;
export type LinkFormQueryResult = ApolloReactCommon.QueryResult<LinkFormQuery, LinkFormQueryVariables>;
export const LinkGeneratorDocument = gql`
    query LinkGenerator($languages: [String]!, $countryCode: String!) {
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
}
    `;

/**
 * __useLinkGeneratorQuery__
 *
 * To run a query within a React component, call `useLinkGeneratorQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkGeneratorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkGeneratorQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useLinkGeneratorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LinkGeneratorQuery, LinkGeneratorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LinkGeneratorQuery, LinkGeneratorQueryVariables>(LinkGeneratorDocument, options);
      }
export function useLinkGeneratorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LinkGeneratorQuery, LinkGeneratorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LinkGeneratorQuery, LinkGeneratorQueryVariables>(LinkGeneratorDocument, options);
        }
export type LinkGeneratorQueryHookResult = ReturnType<typeof useLinkGeneratorQuery>;
export type LinkGeneratorLazyQueryHookResult = ReturnType<typeof useLinkGeneratorLazyQuery>;
export type LinkGeneratorQueryResult = ApolloReactCommon.QueryResult<LinkGeneratorQuery, LinkGeneratorQueryVariables>;
export const ProActivePageDocument = gql`
    query ProActivePage($languages: [String]!, $formName: String!, $countryCode: String!, $tenantId: Int!) {
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
  form(name: $formName, countryCode: $countryCode) {
    ...FormFragment
  }
  branchesForProActiveApplications(tenantId: $tenantId) {
    sid
    gebiet
    ort
    plz
    strasse
    standort
    standortExtern
  }
}
    ${FormFragmentFragmentDoc}`;

/**
 * __useProActivePageQuery__
 *
 * To run a query within a React component, call `useProActivePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProActivePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProActivePageQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *      formName: // value for 'formName'
 *      countryCode: // value for 'countryCode'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useProActivePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProActivePageQuery, ProActivePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProActivePageQuery, ProActivePageQueryVariables>(ProActivePageDocument, options);
      }
export function useProActivePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProActivePageQuery, ProActivePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProActivePageQuery, ProActivePageQueryVariables>(ProActivePageDocument, options);
        }
export type ProActivePageQueryHookResult = ReturnType<typeof useProActivePageQuery>;
export type ProActivePageLazyQueryHookResult = ReturnType<typeof useProActivePageLazyQuery>;
export type ProActivePageQueryResult = ApolloReactCommon.QueryResult<ProActivePageQuery, ProActivePageQueryVariables>;
export const ThankyouTeasersDocument = gql`
    query ThankyouTeasers($languages: [String]!, $countryCode: String!) {
  frontendTranslations(languages: $languages) {
    language
    translations {
      key
      value
    }
  }
  frontendConfigurations(countryCode: $countryCode) {
    key
    value
  }
  recoTeasers(countryCode: $countryCode) {
    ...RecoTeaserFragment
  }
  thankyouTeasers(countryCode: $countryCode) {
    ...ThankYouTeaserFragment
  }
}
    ${RecoTeaserFragmentFragmentDoc}
${ThankYouTeaserFragmentFragmentDoc}`;

/**
 * __useThankyouTeasersQuery__
 *
 * To run a query within a React component, call `useThankyouTeasersQuery` and pass it any options that fit your needs.
 * When your component renders, `useThankyouTeasersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThankyouTeasersQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useThankyouTeasersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ThankyouTeasersQuery, ThankyouTeasersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ThankyouTeasersQuery, ThankyouTeasersQueryVariables>(ThankyouTeasersDocument, options);
      }
export function useThankyouTeasersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ThankyouTeasersQuery, ThankyouTeasersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ThankyouTeasersQuery, ThankyouTeasersQueryVariables>(ThankyouTeasersDocument, options);
        }
export type ThankyouTeasersQueryHookResult = ReturnType<typeof useThankyouTeasersQuery>;
export type ThankyouTeasersLazyQueryHookResult = ReturnType<typeof useThankyouTeasersLazyQuery>;
export type ThankyouTeasersQueryResult = ApolloReactCommon.QueryResult<ThankyouTeasersQuery, ThankyouTeasersQueryVariables>;